<template>
  <b-container fluid>
    <!-- Top Section !-->
    <b-row>
      <b-col lg="12">
        <iq-card>
          <template v-slot:headerTitle>
            <h4 class="card-title text-primary"><strong>OPERATIONAL</strong></h4>
          </template>
          <template v-slot:body>
            <b-row>
              <b-col class="h-auto" :md="$route.query?.preview ? '12' : '8'" ref="leftContent" style="max-height: max-content;">
                <div class="d-flex align-items-center justify-content-between w-100">
                  <h5 class="card-title text-primary mb-4"><strong>INPUT DAILY OPERATIONAL</strong></h5>
                  <b-button v-if="$route.query?.preview !== undefined || $route.query?.preview" type="submit" variant="primary" @click="toEditHistory($route.query?.activityEditId)"><i class="fa fa-pen"></i> {{ $route?.query?.preview ? 'Edit' : 'Preview' }}</b-button>
                </div>
                <hr>
                <b-row>
                  <b-col md="3">
                    <b-form-group label="First Fleet *" label-for="first_fleet">
                      <h5><strong>{{ !isEdit ? fleet.name :  fleetEdit.name }}</strong></h5>
                    </b-form-group>
                  </b-col>
                  <template v-if="!loadingOperational">
                    <b-col md="3">
                      <b-form-group label="Activity Type" label-for="activityType" v-if="formOperationalActivity.activityType">
                        <template v-for="(item,index) in activityTypeOpt">
                          <b-form-radio inline v-model="formOperationalActivity.activityType" :name="item.name" :key="index" :value="item.value" :disabled="loadingCheck || (locked) || $route.query?.preview || $route.query?.activityEditId">{{ item.label }}</b-form-radio>
                        </template>
                      </b-form-group>
                    </b-col>  
                    <b-col md="3">
                      <b-form-group label-for="new_trip" label="New Trip" v-if="formOperationalActivity.activityType === 'trip'">
                          <b-form-checkbox  checkbox
                            v-model="formOperationalActivity.newTrip"
                            switch
                            @input="val => { 
                              if (val) {
                                if(!locked) formOperationalActivity.voyageActivityType = 'UNTOWING'
                                formOperationalActivity.isCrossTrip = false
                              }
                            }"
                            :value="true"
                            :unchecked-value="false"
                            :disabled="locked || (unfinishedTrip.length > 0 && unfinishedTrip.every(el => el.checked))  || $route.query?.preview || $route.query?.activityEditId"
                          >
                            Yes / No
                          </b-form-checkbox>
                      </b-form-group>
                    </b-col>  
                    <b-col md="3">
                      <b-form-group label-for="crossTrip" label="Cross Trip?" v-if="!formOperationalActivity.newTrip && formOperationalActivity.activityType === 'trip'">
                        <b-form-checkbox
                          v-model="formOperationalActivity.isCrossTrip"
                          switch
                          :value="true"
                          :unchecked-value="false"
                          :disabled="locked || $route.query?.preview"
                        >
                          Yes / No
                        </b-form-checkbox>
                      </b-form-group>
                    </b-col>
                    <b-col md="12">
                      <hr>
                      <!-- v-if="!formOperationalActivity.newTrip" -->
                      <b-row v-if="!$route.query?.activityEditId && formOperationalActivity.activityType === 'trip'">
                        <b-col md="12">
                          <div class="d-flex flex-column mb-2" v-if="!formOperationalActivity.isCrossTrip && !formOperationalActivity.newTrip && unfinishedTrip.length">
                            <div class="d-flex align-items-start justify-content-start w-100">
                              <h6 class="card-title text-primary mb-2"><strong>UNFINISHED TRIP </strong></h6>
                            </div>
                            <div class="d-flex overflow-auto border">
                              <table class="table table-striped " v-if="unfinishedTrip.length > 0">
                                <thead>
                                  <tr>
                                    <th rowspan="2"  class=" align-middle">#</th>
                                    <th rowspan="2" class=" text-truncate  align-middle">Start Date</th>
                                    <th rowspan="2" class=" text-truncate  align-middle">End Date</th>
                                    <th rowspan="2" class=" text-truncate  align-middle">Sub Project</th>
                                    <th rowspan="2" class=" text-truncate  align-middle">Fleet</th>
                                    <th colspan="12" class=" text-center">Port of Loading</th>
                                    <th colspan="12" class=" text-center bg-warning">Port of Discharge</th>
                                  </tr>
                                  <tr>
                                    <th class=" text-truncate">POL</th>
                                    <th class=" text-truncate">Agent POL</th>
                                    <th class=" text-truncate">Draught Survey</th>
                                    <!-- <th class=" text-truncate">Arival Time POL</th> -->
                                    <th class=" text-truncate">Anchor Up</th>
                                    <th class=" text-truncate">In Position / Berthing</th>
                                    <th class=" text-truncate">Commenced</th>
                                    <th class=" text-truncate">Completed</th>
                                    <th class=" text-truncate">Second Berthing</th>
                                    <th class=" text-truncate">Cast Out</th>
                                    <th class=" text-truncate">LHV</th>
                                    <th class=" text-truncate">Document on Board</th>
                                    <th class=" text-truncate">Departure to POD</th>
                                    <th class=" text-truncate bg-warning">POD</th>
                                    <th class=" text-truncate bg-warning">Agent POD</th>
                                    <th class=" text-truncate bg-warning">Draught Survey</th>
                                    <th class=" text-truncate bg-warning">Arival Time POD</th>
                                    <th class=" text-truncate bg-warning">Anchor Up</th>
                                    <th class=" text-truncate bg-warning">In Position / Berthing</th>
                                    <th class=" text-truncate bg-warning">Commenced</th>
                                    <th class=" text-truncate bg-warning">Completed</th>
                                    <th class=" text-truncate bg-warning">Second Berthing</th>
                                    <th class=" text-truncate bg-warning">Cast Out</th>
                                    <!-- <th class=" text-truncate">LHV</th> -->
                                    <!-- <th class=" text-truncate">Document on Board</th> -->
                                    <th class=" text-truncate bg-warning">Departure to POL</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr v-for="(state, index) in unfinishedTrip" :key="index">
                                    <td>
                                      <b-form-checkbox :disabled="locked || $route.query?.preview" v-model="state.checked" @change="onCheckedUnfinishedTrip(index)" />
                                    </td>
                                    <td class="text-truncate">
                                      {{ state?.startDate ? moment(state?.startDate, 'DD-MM-YYYY HH:mm').format('DD MMM YYYY HH:mm') : '-' }}
                                    </td>
                                    <td class="text-truncate">
                                      {{ state?.endDate ? moment(state?.endDate, 'DD-MM-YYYY HH:mm').format('DD MMM YYYY HH:mm') : '-' }}
                                    </td>
                                    <td class="text-truncate">
                                      {{ state?.subProject?.project?.projectName }} - {{ state?.subProject?.name }} 
                                    </td>
                                    <td class="text-truncate">
                                      <div class="d-flex">
                                        <div v-for="(fleet, i) in state?.vehicle" :key="i" class="d-flex align-items-center">
                                          <b-badge variant="success" >{{ fleet?.name }}</b-badge>
                                          <LinkIcon v-if="i == 0 && state?.vehicle?.length > 1" class="mx-2"/>
                                        </div>
                                      </div>
                                    </td>
                                    <td class="text-truncate">
                                      {{ state?.portLoading?.portName || state?.portLoadingOther }}
                                    </td>
                                    <td class="text-truncate">{{state?.agentPol}}</td>
                                    <td class="text-truncate text-center">{{Number(state?.polDraughtSurvey)?.toLocaleString() || 0}}</td>
                                    <!-- <td class="text-truncate">
                                      {{ state?.polArrivalTime ? moment(state?.polArrivalTime, 'DD-MM-YYYY HH:mm').format('DD MMM YYYY HH:mm') : '-' }}
                                    </td> -->
                                    <td class="text-truncate">
                                      {{ state?.polAnchorUp ? moment(state?.polAnchorUp, 'DD-MM-YYYY HH:mm').format('DD MMM YYYY HH:mm') : '-' }}
                                    </td>
                                    <td class="text-truncate">
                                      {{ state?.polBerthing ? moment(state?.polBerthing, 'DD-MM-YYYY HH:mm').format('DD MMM YYYY HH:mm') : '-' }}
                                    </td>
                                    <td class="text-truncate">
                                      {{ state?.polCommenced ? moment(state?.polCommenced, 'DD-MM-YYYY HH:mm').format('DD MMM YYYY HH:mm') : '-' }}
                                    </td>
                                    <td class="text-truncate">
                                      {{ state?.polCompleted ? moment(state?.polCompleted, 'DD-MM-YYYY HH:mm').format('DD MMM YYYY HH:mm') : '-' }}
                                    </td>
                                    <td class="text-truncate">
                                      {{ state?.polCastIn ? moment(state?.polCastIn, 'DD-MM-YYYY HH:mm').format('DD MMM YYYY HH:mm') : '-' }}
                                    </td> 
                                    <td class="text-truncate">
                                      {{ state?.polCastOut ? moment(state?.polCastOut, 'DD-MM-YYYY HH:mm').format('DD MMM YYYY HH:mm') : '-' }}
                                    </td> 
                                    <td class="text-truncate">
                                      {{ state?.polLhv ? moment(state?.polLhv, 'DD-MM-YYYY HH:mm').format('DD MMM YYYY HH:mm') : '-' }}
                                    </td>
                                    <td class="text-truncate">
                                      {{ state?.polDocOnBoard ? moment(state?.polDocOnBoard, 'DD-MM-YYYY HH:mm').format('DD MMM YYYY HH:mm') : '-' }}
                                    </td>
                                    <td class="text-truncate">
                                      {{ state?.polDeparture ? moment(state?.polDeparture, 'DD-MM-YYYY HH:mm').format('DD MMM YYYY HH:mm') : '-' }}
                                    </td>
                                    <td class="text-truncate">
                                      {{ state?.portDischarge?.portName || state?.portDischargeOther }}
                                    </td>
                                    <td class="text-truncate">{{state?.agentPod}}</td>
                                    <td class="text-truncate text-center">{{Number(state?.podDraughtSurvey)?.toLocaleString() || 0}}</td>
                                    <td class="text-truncate">
                                      {{ state?.podArrivalTime ? moment(state?.podArrivalTime, 'DD-MM-YYYY HH:mm').format('DD MMM YYYY HH:mm') : '-' }}
                                    </td>
                                    <td class="text-truncate">
                                      {{ state?.podAnchorUp ? moment(state?.podAnchorUp, 'DD-MM-YYYY HH:mm').format('DD MMM YYYY HH:mm') : '-' }}
                                    </td>
                                    <td class="text-truncate">
                                      {{ state?.podBerthing ? moment(state?.podBerthing, 'DD-MM-YYYY HH:mm').format('DD MMM YYYY HH:mm') : '-' }}
                                    </td>
                                    <td class="text-truncate">
                                      {{ state?.podCommenced ? moment(state?.podCommenced, 'DD-MM-YYYY HH:mm').format('DD MMM YYYY HH:mm') : '-' }}
                                    </td>
                                    <td class="text-truncate">
                                      {{ state?.podCompleted ? moment(state?.podCompleted, 'DD-MM-YYYY HH:mm').format('DD MMM YYYY HH:mm') : '-' }}
                                    </td>
                                    <td class="text-truncate">
                                      {{ state?.podCastIn ? moment(state?.podCastIn, 'DD-MM-YYYY HH:mm').format('DD MMM YYYY HH:mm') : '-' }}
                                    </td> 
                                    <td class="text-truncate">
                                      {{ state?.podCastOut ? moment(state?.podCastOut, 'DD-MM-YYYY HH:mm').format('DD MMM YYYY HH:mm') : '-' }}
                                    </td> 
                                    <!-- <td class="text-truncate">
                                      {{ state?.podLhv ? moment(state?.podLhv, 'DD-MM-YYYY HH:mm').format('DD MMM YYYY HH:mm') : '-' }}
                                    </td> -->
                                    <!-- <td class="text-truncate">
                                      {{ state?.docOnBoard ? moment(state?.docOnBoard, 'DD-MM-YYYY HH:mm').format('DD MMM YYYY HH:mm') : '-' }}
                                    </td> -->
                                    <td class="text-truncate">
                                      {{ state?.podDeparture ? moment(state?.podDeparture, 'DD-MM-YYYY HH:mm').format('DD MMM YYYY HH:mm') : '-' }}
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                              <strong class="text-center text-muted" v-else><span v-if="!formOperationalActivity.isCrossTrip">No Data Found.</span></strong>
                            </div>
                          </div>
                        </b-col>
                        <b-col md="12" v-if="formOperationalActivity.isCrossTrip && !formOperationalActivity.newTrip">
                          <b-form-group label="Fleet" label-for="fleet">
                            <v-select
                              label="text"
                              :options="optionsFleets?.filter((el)=> el.value != $route.query?.vehicleId)"
                              :reduce="
                                (optionsFleets) => optionsFleets.value

                              "
                              placeholder="Select..."
                              v-model="formOperationalActivity.fleetId"
                              @input="onChangeFleet"
                              :disabled="$route.query?.preview || locked"
                            ></v-select>
                          </b-form-group>
                        </b-col>
                        <b-col md="12" v-if="formOperationalActivity.isCrossTrip && !formOperationalActivity.newTrip">
                          <div class="d-flex flex-column mb-2">
                            <h6 class="card-title text-primary mb-2"><strong>UNFINISHED TRIP (Cross Trip)</strong></h6>
                            <strong class="text-muted" v-if="!formOperationalActivity.fleetId">Select Vehicle.</strong>
                            <div class="d-flex overflow-auto border" v-if="crossTripList.length > 0">
                              <table class="table table-striped ">
                                <thead>
                                  <tr>
                                    <th rowspan="2"  class=" align-middle">#</th>
                                    <th rowspan="2" class=" text-truncate  align-middle">Start Date</th>
                                    <th rowspan="2" class=" text-truncate  align-middle">End Date</th>
                                    <th rowspan="2" class=" text-truncate  align-middle">Sub Project</th>
                                    <th rowspan="2" class=" text-truncate  align-middle">Fleet</th>
                                    <th colspan="12" class=" text-center">Port of Loading</th>
                                    <th colspan="12" class=" text-center bg-warning">Port of Discharge</th>
                                  </tr>
                                  <tr>
                                    <th class=" text-truncate">POL</th>
                                    <th class=" text-truncate">Agent POL</th>
                                    <th class=" text-truncate">Draught Survey</th>
                                    <!-- <th class=" text-truncate">Arival Time POL</th> -->
                                    <th class=" text-truncate">Anchor Up</th>
                                    <th class=" text-truncate">In Position / Berthing</th>
                                    <th class=" text-truncate">Commenced</th>
                                    <th class=" text-truncate">Completed</th>
                                    <th class=" text-truncate">Second Berthing</th>
                                    <th class=" text-truncate">Cast Out</th>
                                    <th class=" text-truncate">LHV</th>
                                    <th class=" text-truncate">Document on Board</th>
                                    <th class=" text-truncate">Departure to POD</th>
                                    <th class=" text-truncate bg-warning">POD</th>
                                    <th class=" text-truncate bg-warning">Agent POD</th>
                                    <th class=" text-truncate bg-warning">Draught Survey</th>
                                    <th class=" text-truncate bg-warning">Arival Time POD</th>
                                    <th class=" text-truncate bg-warning">Anchor Up</th>
                                    <th class=" text-truncate bg-warning">In Position / Berthing</th>
                                    <th class=" text-truncate bg-warning">Commenced</th>
                                    <th class=" text-truncate bg-warning">Completed</th>
                                    <th class=" text-truncate bg-warning">Second Berthing</th>
                                    <th class=" text-truncate bg-warning">Cast Out</th>
                                    <!-- <th class=" text-truncate">LHV</th> -->
                                    <!-- <th class=" text-truncate">Document on Board</th> -->
                                    <th class=" text-truncate bg-warning">Departure to POL</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr v-for="(state, index) in crossTripList" :key="index">
                                    <td>
                                      <b-form-checkbox :disabled="locked" v-model="state.checked" @change="onCheckedCrossTrip(state,index)" />
                                    </td>
                                    <td class="text-truncate">
                                      {{ state?.startDate ? moment(state?.startDate, 'DD-MM-YYYY HH:mm').format('DD MMM YYYY HH:mm') : '-' }}
                                    </td>
                                    <td class="text-truncate">
                                      {{ state?.endDate ? moment(state?.endDate, 'DD-MM-YYYY HH:mm').format('DD MMM YYYY HH:mm') : '-' }}
                                    </td>
                                    <td class="text-truncate">
                                      {{ state?.subProject?.project?.projectName }} - {{ state?.subProject?.name }} 
                                    </td>
                                    <td class="text-truncate">
                                       <div class="d-flex">
                                        <div v-for="(fleet, i) in state?.vehicle" :key="i" class="d-flex align-items-center">
                                          <b-badge variant="success" >{{ fleet?.name }}</b-badge>
                                          <LinkIcon v-if="i == 0 && state?.vehicle?.length > 1" class="mx-2"/>
                                        </div>
                                      </div>
                                      <!-- <p class="m-0" v-for="(fleet, i) in state?.vehicle?.filter((el)=>el.id != $route.query.vehicleId)" :key="i">{{ fleet.name }}asdsd</p> -->
                                    </td>
                                    <td class="text-truncate">
                                      {{ state?.portLoading?.portName || state?.portLoadingOther }}
                                    </td>
                                    <td class="text-truncate">{{state?.agentPol}}</td>
                                    <td class="text-truncate text-center">{{Number(state?.polDraughtSurvey).toLocaleString() || 0}}</td>
                                    <!-- <td class="text-truncate">
                                      {{ state?.polArrivalTime ? moment(state?.polArrivalTime, 'DD-MM-YYYY HH:mm').format('DD MMM YYYY HH:mm') : '-' }}
                                    </td> -->
                                    <td class="text-truncate">
                                      {{ state?.polAnchorUp ? moment(state?.polAnchorUp, 'DD-MM-YYYY HH:mm').format('DD MMM YYYY HH:mm') : '-' }}
                                    </td>
                                    <td class="text-truncate">
                                      {{ state?.polBerthing ? moment(state?.polBerthing, 'DD-MM-YYYY HH:mm').format('DD MMM YYYY HH:mm') : '-' }}
                                    </td>
                                    <td class="text-truncate">
                                      {{ state?.polCommenced ? moment(state?.polCommenced, 'DD-MM-YYYY HH:mm').format('DD MMM YYYY HH:mm') : '-' }}
                                    </td>
                                    <td class="text-truncate">
                                      {{ state?.polCompleted ? moment(state?.polCompleted, 'DD-MM-YYYY HH:mm').format('DD MMM YYYY HH:mm') : '-' }}
                                    </td>
                                    <td class="text-truncate">
                                      {{ state?.polCastIn ? moment(state?.polCastIn, 'DD-MM-YYYY HH:mm').format('DD MMM YYYY HH:mm') : '-' }}
                                    </td> 
                                    <td class="text-truncate">
                                      {{ state?.polCastOut ? moment(state?.polCastOut, 'DD-MM-YYYY HH:mm').format('DD MMM YYYY HH:mm') : '-' }}
                                    </td> 
                                    <td class="text-truncate">
                                      {{ state?.polLhv ? moment(state?.polLhv, 'DD-MM-YYYY HH:mm').format('DD MMM YYYY HH:mm') : '-' }}
                                    </td>
                                    <td class="text-truncate">
                                      {{ state?.polDocOnBoard ? moment(state?.polDocOnBoard, 'DD-MM-YYYY HH:mm').format('DD MMM YYYY HH:mm') : '-' }}
                                    </td>
                                    <td class="text-truncate">
                                      {{ state?.polDeparture ? moment(state?.polDeparture, 'DD-MM-YYYY HH:mm').format('DD MMM YYYY HH:mm') : '-' }}
                                    </td>
                                    <td class="text-truncate">
                                      {{ state?.portDischarge?.portName || state?.portDischargeOther  }}
                                    </td>
                                    <td class="text-truncate">{{state?.agentPod}}</td>
                                    <td class="text-truncate text-center">{{Number(state?.podDraughtSurvey).toLocaleString() || 0}}</td>
                                    <td class="text-truncate">
                                      {{ state?.podArrivalTime ? moment(state?.podArrivalTime, 'DD-MM-YYYY HH:mm').format('DD MMM YYYY HH:mm') : '-' }}
                                    </td>
                                    <td class="text-truncate">
                                      {{ state?.podAnchorUp ? moment(state?.podAnchorUp, 'DD-MM-YYYY HH:mm').format('DD MMM YYYY HH:mm') : '-' }}
                                    </td>
                                    <td class="text-truncate">
                                      {{ state?.podBerthing ? moment(state?.podBerthing, 'DD-MM-YYYY HH:mm').format('DD MMM YYYY HH:mm') : '-' }}
                                    </td>
                                    <td class="text-truncate">
                                      {{ state?.podCommenced ? moment(state?.podCommenced, 'DD-MM-YYYY HH:mm').format('DD MMM YYYY HH:mm') : '-' }}
                                    </td>
                                    <td class="text-truncate">
                                      {{ state?.podCompleted ? moment(state?.podCompleted, 'DD-MM-YYYY HH:mm').format('DD MMM YYYY HH:mm') : '-' }}
                                    </td>
                                     <td class="text-truncate">
                                      {{ state?.podCastIn ? moment(state?.podCastIn, 'DD-MM-YYYY HH:mm').format('DD MMM YYYY HH:mm') : '-' }}
                                    </td> 
                                    <td class="text-truncate">
                                      {{ state?.podCastOut ? moment(state?.podCastOut, 'DD-MM-YYYY HH:mm').format('DD MMM YYYY HH:mm') : '-' }}
                                    </td> 
                                    <!-- <td class="text-truncate">
                                      {{ state?.podLhv ? moment(state?.podLhv, 'DD-MM-YYYY HH:mm').format('DD MMM YYYY HH:mm') : '-' }}
                                    </td> -->
                                    <!-- <td class="text-truncate">
                                      {{ state?.docOnBoard ? moment(state?.docOnBoard, 'DD-MM-YYYY HH:mm').format('DD MMM YYYY HH:mm') : '-' }}
                                    </td> -->
                                    <td class="text-truncate">
                                      {{ state?.podDeparture ? moment(state?.podDeparture, 'DD-MM-YYYY HH:mm').format('DD MMM YYYY HH:mm') : '-' }}
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                            <strong class="text-center text-muted" v-if="crossTripList.length <= 0 && formOperationalActivity.fleetId">No Data found.</strong>
                          </div>
                        </b-col>
                      </b-row>
                      <!-- Showed with special Condition -->
                      <template v-if="formOperationalActivity.newTrip || isUnfinishedTripChecked || isCrossTripChecked || isEdit || $route.query.activityEditId || formOperationalActivity.activityType === 'non trip'">
                        <b-form-group label="Voyage with" label-for="voyage_with" v-if="showVoyageWidth">
                          <b-form-radio class="custom-radio-color-checked" inline v-model="formOperationalActivity.voyageActivityType" color="default" name="color" value="UNTOWING" :disabled="loadingCheck || (locked && !isEdit) || $route.query?.preview">Towing Free</b-form-radio>
                          <b-form-radio class="custom-radio-color-checked" inline v-model="formOperationalActivity.voyageActivityType" color="primary" name="color" value="SINGLE_TOWING" :disabled="loadingCheck || (locked && !isEdit) || $route.query?.preview">Single Towing</b-form-radio>
                          <b-form-radio class="custom-radio-color-checked" inline v-model="formOperationalActivity.voyageActivityType" color="primary" name="color" value="DOUBLE_TOWING" :disabled="loadingCheck || (locked && !isEdit) || $route.query?.preview">Double Towing</b-form-radio>
                        </b-form-group>
                        <b-row>
                          <b-col md="6" v-if="formOperationalActivity.voyageActivityType === 'SINGLE_TOWING' || formOperationalActivity.voyageActivityType === 'DOUBLE_TOWING'" >
                              <b-row class="mb-3">
                                <b-col md="7">
                                  <label for="second_fleet">Second Fleet *</label>
                                </b-col>
                                <b-col md="5" class="text-right">
                                  <b-form-checkbox v-model="formOperationalActivity.vehicles[0].breakdown" name="check-button" switch inline :disabled="loadingCheck || (locked && !isEdit) || $route.query?.preview">
                                    Breakdown ?
                                  </b-form-checkbox>
                                </b-col>
                                <b-col md="12">
                                  <v-select v-model="formOperationalActivity.vehicles[0].vehicleId" label="name" required placeholder="Select..." :options="fleetListFiltered" :reduce="(fleetList) => fleetList.id" :disabled="(locked && !isEdit) || loadingCheck || $route.query?.preview" v-on:input="handleSelectFleet(fleetList, $event, 0)"></v-select>
                                </b-col>
                              </b-row>
                          </b-col>
                          <b-col md="6" v-if="formOperationalActivity.voyageActivityType === 'DOUBLE_TOWING'" >
                            <b-row class="mb-3">
                              <b-col md="7">
                                <label for="another_fleet">Another Fleet *</label>
                              </b-col>
                              <b-col md="5" class="text-right">
                                <b-form-checkbox v-model="formOperationalActivity.vehicles[1].breakdown" name="check-button" switch inline :disabled="loadingCheck || (locked && !isEdit) || $route.query?.preview">
                                  Breakdown ?
                                </b-form-checkbox>
                              </b-col>
                              <b-col md="12">
                                <v-select v-model="formOperationalActivity.vehicles[1].vehicleId" label="name" :options="fleetListFiltered" :reduce="(fleetList) => fleetList.id" :disabled="loadingCheck || (locked && !isEdit) || $route.query?.preview" v-on:input="handleSelectFleet(fleetList, $event, 1)"></v-select>
                              </b-col>
                            </b-row>
                          </b-col>
                        </b-row>
                        <hr>
                      </template>
                    </b-col>
                    <!-- Showed with special Condition -->
                    <template v-if="formOperationalActivity.newTrip || isUnfinishedTripChecked || isCrossTripChecked || isEdit || formOperationalActivity.activityType === 'non trip'">
                      <b-col md="6">
                        <b-form-group label="Start Date Activity *" label-for="start_date">
                          <date-picker v-model="formOperationalActivity.startDate" :class="{ 'border-danger': $v.formOperationalActivity.startDate.$error }" class="custom-date-picker" value-type="DD-MM-YYYY HH:mm" type="datetime" placeholder="Select date and time" format="DD-MM-YYYY HH:mm" :disabled="(locked && !isEdit) || loadingCheck || $route.query?.preview"></date-picker>
                          <p><small v-if="$v.formOperationalActivity.startDate.$error  && !$v.formOperationalActivity.startDate.required " class="text-danger m-t-5">Start Date is Required</small></p>
                        </b-form-group>
                      </b-col>
                      <b-col md="6">
                        <b-form-group label="End Date Activity *" label-for="end_date">
                          <date-picker v-model="formOperationalActivity.endDate" :class="{ 'border-danger': $v.formOperationalActivity.startDate.$error }" class="custom-date-picker" value-type="DD-MM-YYYY HH:mm" type="datetime" placeholder="Select date and time" format="DD-MM-YYYY HH:mm" :disabled="(locked && !isEdit) || loadingCheck || $route.query?.preview"></date-picker>
                          <p><small v-if="$v.formOperationalActivity.endDate.$error  && !$v.formOperationalActivity.endDate.required " class="text-danger m-t-5">End Date is Required</small></p>
                        </b-form-group>
                      </b-col>
                      <b-col md="12" v-if="!isEdit || !$route.query?.preview">
                        <b-form-group label="" label-for="process">
                          <b-button block variant="success" v-if="!loadingCheck" class="mt-3" @click.prevent="checkVoyage" :disabled="locked || $route.query.activityEditId"><i class="fa fa-map-pin"></i>Process</b-button>
                          <b-button block variant="light" v-else class="mt-3" @click.prevent="edit"><i class="fa fa-edit"></i>Edit</b-button>
                          <b-button block variant="danger" v-if="nextStep || locked" class="mt-3" @click.prevent="resetForm" type="button"><i class="fa fa-ban"></i>Reset Form</b-button>
                        </b-form-group>
                      </b-col>
                    </template>
                  </template>
                </b-row>
                <hr>
                <template v-if="(nextStep && !loadingOperational && !isActivityId ) || (isActivityId && !loadingOperational)">
                  <b-col md="12" class="my-4">
                    <div class="d-flex align-items-center justify-content-end w-100">
                      <b-button variant="primary" class="mr-2" @click="saveDraft"><i class="fa fa-save"></i>Save Draft</b-button>
                      <b-button variant="secondary"  @click="pasteDraft"><i class="fa fa-clipboard"></i>Paste Draft</b-button>
                    </div>
                  </b-col>

                  <!-- NEW ACTIVITY DATA FORM -->
                  <b-col md="12" v-if="formOperationalActivity.activityType === 'trip'">
                    <b-row>
                      <b-col md="12">
                        <fieldset class="form-group border p-3 iq-bg-info">
                          <legend class="w-auto px-2 text-primary h6"><strong>PROJECT RECORD</strong></legend>
                          <b-form>
                            <b-form-group label="Project *" label-for="project">
                              <v-select 
                                v-model="formOperationalActivity.subProjectId" 
                                :options="projectOptions" 
                                :reduce="option => option.value" 
                                placeholder="Select one" 
                                track-by="value" 
                                label="text" 
                                :disabled="$route.query?.preview"
                                @input="handleChangeProject"
                                class="bg-white"
                                required
                              />
                            </b-form-group>
                          </b-form>
                        </fieldset>
                      </b-col>
                      <b-col md="12">
                        <hr>
                      </b-col>
                      <b-col md="6">
                        <fieldset class="form-group border p-3 iq-bg-info">
                          <legend class="w-auto px-2 text-primary h6"><strong>LOADING ACTIVITY RECORD</strong></legend>
                          <b-form-row>
                            <b-col md="6">
                              <b-form-group label="Port of Loading" label-for="port_of_loading">
                                <v-select :disabled="$route.query?.preview" v-model="formOperationalActivity.portLoading" label="text" :options="positionListPOL" :reduce="positionListPOL => positionListPOL.value" placeholder="Select..." class="bg-white" @input="handleOriginChange"></v-select>
                              </b-form-group>
                            </b-col>
                            <b-col v-if="['Other'].includes(formOperationalActivity.portLoading)" md="6">
                              <b-form-group label="Other POL" label-for="POL">
                                <b-form-input 
                                  class="bg-white" type="text" v-model="formOperationalActivity.portLoadingOther" :disabled="$route.query?.preview"
                                  @blur="() => formOperationalActivity.originOther = formOperationalActivity.portLoadingOther"
                                />
                              </b-form-group>
                            </b-col>
                            <b-col md="6">
                              <b-form-group label="Agent POL" label-for="agent_pol" class="text-truncate">
                                <b-form-input :disabled="$route.query?.preview" v-model="formOperationalActivity.agentPol" @change="() => {
                                  formOperationalActivity.agentPod = formOperationalActivity.agentPol
                                }" type="text" id="agent_pol" placeholder="Type Text" class="bg-white"></b-form-input>
                              </b-form-group>
                            </b-col>
                            <b-col md="6" v-if="['Other'].includes(formOperationalActivity.portLoading)"></b-col>
                            <b-col md="6">
                              <b-form-group label="Is Pol Sts Mv:" label-for="kind-fleet">
                                  <b-form-checkbox :disabled="$route.query?.preview" v-model="formOperationalActivity.polStsMv" name="check-button" switch inline :key="index">
                                    No / Yes
                                  </b-form-checkbox>
                              </b-form-group>
                            </b-col>
                            <b-col md="6">
                              <b-form-group label="Pol Mv Name" label-for="pol_mv_name" class="text-truncate" v-if="formOperationalActivity.polStsMv">
                                <b-form-input v-model="formOperationalActivity.polMvName" type="text" id="pol_mv_name" placeholder="Type Text" :class="{'bg-white':formOperationalActivity.polStsMv}" :disabled="!formOperationalActivity.polStsMv || $route.query?.preview"></b-form-input>
                              </b-form-group>
                            </b-col>
                            <b-col md="6">
                              <b-form-group label="Pol grab Type" label-for="pod_grab_type">
                                <v-select :disabled="$route.query?.preview" v-model="formOperationalActivity.polGrabType" label='text' :options="polGrabTypeOpt" :reduce="item => item.value"  placeholder="Select Pol Grab Type" class="bg-white"></v-select>
                              </b-form-group>
                            </b-col>
                            <b-col md="6">
                              <b-form-group label="Pol Fc Name" label-for="pol_fc_name" class="text-truncate" v-if="formOperationalActivity.polGrabType == 'gearless'">
                                <b-form-input v-model="formOperationalActivity.polFcName" :class="{'bg-white' : formOperationalActivity.polGrabType == 'gearless'}" :disabled="formOperationalActivity.polGrabType !== 'gearless' || $route.query?.preview" type="text" id="pol_mv_name" placeholder="Type Text"></b-form-input>
                              </b-form-group>
                            </b-col>
                            <!-- Data Not Yet Provided -->
                            <b-col md="6" class="mb-2"> 
                              <b-form-group label="NOR" label-for="nor" class="text-truncate mb-0">
                                <date-picker :disabled="$route.query?.preview" v-model="formOperationalActivity.polNor" class="custom-date-picker" value-type="DD-MM-YYYY HH:mm" type="datetime" placeholder="Select date" format="DD-MM-YYYY HH:mm"></date-picker>
                              </b-form-group>
                            </b-col>
                            <!-- Data Not Yet Provided -->
                            <b-col md="6" class="mb-2"> 
                              <b-form-group label="NOA" label-for="noa" class="text-truncate mb-0">
                                <date-picker :disabled="$route.query?.preview" v-model="formOperationalActivity.polNoa" class="custom-date-picker" value-type="DD-MM-YYYY HH:mm" type="datetime" placeholder="Select date" format="DD-MM-YYYY HH:mm"></date-picker>
                              </b-form-group>
                            </b-col>
                            <b-col md="6" class="mb-2">
                              <b-form-group label="Anchor Up" label-for="polAnchorUp" class="text-truncate mb-0">
                                <date-picker :disabled="$route.query?.preview" @change="validationTime(formOperationalActivity.polArrivalTime, formOperationalActivity.polAnchorUp, 'Anchor Up', 'Arrival Time', 1)" class="custom-date-picker" v-model="formOperationalActivity.polAnchorUp" value-type="DD-MM-YYYY HH:mm" type="datetime" placeholder="Select date" format="DD-MM-YYYY HH:mm"></date-picker>
                              </b-form-group>
                              <small v-if="errorTimeText && errorTimeIndex === 1" class="text-danger" style="margin-top:-30px">*{{ errorTimeText}}</small>
                            </b-col>
                            <b-col  md="6" class="mb-2">
                              <b-form-group label="In Position / Berthing" label-for="polBerthing" class="text-truncate mb-0">
                                <date-picker :disabled="$route.query?.preview" @change="validationTime(formOperationalActivity.polAnchorUp, formOperationalActivity.polBerthing, 'Berthing', 'Anchor Up', 2)"  class="custom-date-picker" v-model="formOperationalActivity.polBerthing" value-type="DD-MM-YYYY HH:mm" type="datetime" placeholder="Select date" format="DD-MM-YYYY HH:mm"></date-picker>
                              </b-form-group>
                              <small v-if="errorTimeText && errorTimeIndex === 2" class="text-danger" style="margin-top:-30px">*{{ errorTimeText}}</small>
                            </b-col>
                            <b-col md="6" class="mb-2">
                              <b-form-group label="Commenced" label-for="polCommenced" class="text-truncate mb-0">
                                <date-picker :disabled="$route.query?.preview" @change="validationTime(formOperationalActivity.polBerthing, formOperationalActivity.polCommenced, 'Commenced', 'Berthing', 3)" class="custom-date-picker"v-model="formOperationalActivity.polCommenced" value-type="DD-MM-YYYY HH:mm" type="datetime" placeholder="Select date" format="DD-MM-YYYY HH:mm"></date-picker>
                              </b-form-group>
                              <small v-if="errorTimeText && errorTimeIndex === 3" class="text-danger" style="margin-top:-30px">*{{ errorTimeText}}</small>
                            </b-col>
                            <b-col md="6" class="mb-2">
                              <b-form-group label="Completed" label-for="completed" class="text-truncate mb-0">
                                <date-picker :disabled="$route.query?.preview" @change="validationTime(formOperationalActivity.polCommenced, formOperationalActivity.polCompleted, 'Completed', 'Commenced', 4)" class="custom-date-picker" v-model="formOperationalActivity.polCompleted" value-type="DD-MM-YYYY HH:mm" type="datetime" placeholder="Select date" format="DD-MM-YYYY HH:mm"></date-picker>
                              </b-form-group>
                              <small v-if="errorTimeText && errorTimeIndex === 4" class="text-danger" style="margin-top:-30px">*{{ errorTimeText}}</small>
                            </b-col>
                            <b-col md="6">
                              <b-form-group label="Draught Survey" label-for="polDraughtSurvey" class="text-truncate mb-0">
                                <InputCurrency
                                  prepend=""
                                  v-model="formOperationalActivity.polDraughtSurvey"
                                  :disabled="$route.query?.preview"
                                  @input="formOperationalActivity.cargoLoading = formOperationalActivity.polDraughtSurvey"
                                  placeholder="Type Number"
                                />
                              </b-form-group>
                            </b-col>
                            <!-- Data Not Yet Provided -->
                            <b-col md="6" class="mb-2"> 
                              <b-form-group label="BL Date" label-for="blDate" class="text-truncate mb-0">
                                <date-picker :disabled="$route.query?.preview" class="custom-date-picker" v-model="formOperationalActivity.polBlDate" value-type="DD-MM-YYYY HH:mm" type="datetime" placeholder="Select date" format="DD-MM-YYYY HH:mm"></date-picker>
                              </b-form-group>
                              <small v-if="errorTimeText && errorTimeIndex === 5" class="text-danger" style="margin-top:-30px">*{{ errorTimeText}}</small>
                            </b-col>
                            <!-- Data Not Yet Provided -->
                            <b-col md="6" class="mb-2"> 
                              <b-form-group label="Second Berthing" label-for="polCastIn" class="text-truncate mb-0">
                                <date-picker :disabled="$route.query?.preview" v-model="formOperationalActivity.polCastIn" class="custom-date-picker" value-type="DD-MM-YYYY HH:mm" type="datetime" placeholder="Select date" format="DD-MM-YYYY HH:mm"></date-picker>
                              </b-form-group>
                              <small v-if="errorTimeText && errorTimeIndex === 5" class="text-danger" style="margin-top:-30px">*{{ errorTimeText}}</small>
                            </b-col>
                            <b-col md="6" class="mb-2">
                              <b-form-group label="Cast out" label-for="polCastOut" class="text-truncate mb-0">
                                <date-picker :disabled="$route.query?.preview" @change="validationTime(formOperationalActivity.polCompleted, formOperationalActivity.polCastOut, 'Cast Out', 'Completed', 5)"  class="custom-date-picker" v-model="formOperationalActivity.polCastOut" value-type="DD-MM-YYYY HH:mm" type="datetime" placeholder="Select date" format="DD-MM-YYYY HH:mm"></date-picker>
                              </b-form-group>
                              <small v-if="errorTimeText && errorTimeIndex === 5" class="text-danger" style="margin-top:-30px">*{{ errorTimeText}}</small>
                            </b-col>
                            <b-col md="6" class="mb-2">
                              <b-form-group label="LHV" label-for="polLhv" class="text-truncate mb-0">
                                <date-picker :disabled="$route.query?.preview" @change="validationTime(formOperationalActivity.polCastOut, formOperationalActivity.polLhv, 'LHV', 'Cast Out', 6)"  class="custom-date-picker" v-model="formOperationalActivity.polLhv" value-type="DD-MM-YYYY HH:mm" type="datetime" placeholder="Select date" format="DD-MM-YYYY HH:mm"></date-picker>
                              </b-form-group>
                              <small v-if="errorTimeText && errorTimeIndex === 6" class="text-danger" style="margin-top:-30px">*{{ errorTimeText}}</small>
                            </b-col>
                            <b-col md="6" class="mb-2"  v-if="showDocumentOnBoard">
                              <b-form-group label="Document On Board POL" label-for="document_on_board" class="text-truncate mb-0">
                                <date-picker :disabled="$route.query?.preview" @change="validationTime(formOperationalActivity.polLhv, formOperationalActivity.polDocOnBoard, 'Doc on Board', 'LHV', 7)" class="custom-date-picker" v-model="formOperationalActivity.polDocOnBoard" value-type="DD-MM-YYYY HH:mm" type="datetime" placeholder="Select date" format="DD-MM-YYYY HH:mm"></date-picker>
                              </b-form-group>
                              <small v-if="errorTimeText && errorTimeIndex === 7" class="text-danger" style="margin-top:-30px">*{{ errorTimeText}}</small>
                            </b-col>
                            <b-col md="6" class="mb-2">
                              <b-form-group label="Departure to POD" label-for="polDeparture" class="text-truncate mb-0">
                                <date-picker :disabled="$route.query?.preview" @change="validationTime(formOperationalActivity.polDocOnBoard, formOperationalActivity.polDeparture, 'Departure', 'Doc on Board', 8)" class="custom-date-picker" v-model="formOperationalActivity.polDeparture" value-type="DD-MM-YYYY HH:mm" type="datetime" placeholder="Select date" format="DD-MM-YYYY HH:mm"></date-picker>
                              </b-form-group>
                              <small v-if="errorTimeText && errorTimeIndex === 8" class="text-danger" style="margin-top:-30px">*{{ errorTimeText}}</small>
                            </b-col>
                            <b-col md="12" class="mb-2"> 
                              <b-form-group label="Remarks" label-for="polCastIn" class="text-truncate mb-0">
                                <b-form-textarea :disabled="$route.query?.preview" placeholder="Type Text..." v-model="formOperationalActivity.polRemark" class="bg-white">
                                </b-form-textarea>
                              </b-form-group>
                            </b-col>
                          </b-form-row>
                        </fieldset>
                      </b-col>
                      <b-col md="6">
                        <fieldset class="form-group border p-3 iq-bg-info">
                          <legend class="w-auto px-2 text-primary h6"><strong>DISCHARGE ACTIVITY RECORD</strong></legend>
                          <b-form-row>
                            <b-col md="6">
                              <b-form-group label="Port of Discharge" label-for="port_of_discharge">
                                <v-select :disabled="$route.query?.preview" class="bg-white" v-model="formOperationalActivity.portDischarge" label="text" :options="positionListPOD" :reduce="positionListPOD => positionListPOD.value" placeholder="Select..." @input="handleDestinationChange"></v-select>
                              </b-form-group>
                            </b-col>
                            <b-col v-if="['Other'].includes(formOperationalActivity.portDischarge)" md="6">
                              <b-form-group label="Other POD" label-for="PODF">
                                <b-form-input 
                                  class="bg-white" type="text" v-model="formOperationalActivity.portDischargeOther" :disabled="$route.query?.preview"
                                  @blur="() => formOperationalActivity.destinationOther = formOperationalActivity.portDischargeOther"
                                />
                              </b-form-group>
                            </b-col>
                            <b-col md="6">
                              <b-form-group label="Agent POD" label-for="agent_pod" class="text-truncate">
                                <b-form-input :disabled="$route.query?.preview" v-model="formOperationalActivity.agentPod" @change="() => {
                                  formOperationalActivity.agentPol = formOperationalActivity.agentPod
                                }" type="text" id="agent_pod" placeholder="Type Text" class="bg-white" ></b-form-input>
                              </b-form-group>
                            </b-col>  
                            <b-col md="6" v-if="['Other'].includes(formOperationalActivity.portDischarge)">
                            </b-col>
                            <b-col md="6">
                              <b-form-group label="Is Pod Sts Mv:" label-for="pod_sts_mv">
                                  <b-form-checkbox :disabled="$route.query?.preview" v-model="formOperationalActivity.podStsMv" name="check-button" switch inline :key="index">
                                    No / Yes 
                                  </b-form-checkbox>
                              </b-form-group>
                            </b-col>
                            <b-col md="6">
                              <b-form-group label="Pod Mv Name" label-for="pod_mv_name" class="text-truncate" v-if="formOperationalActivity.podStsMv">
                                <b-form-input v-model="formOperationalActivity.podMvName" type="text" id="pol_mv_name" placeholder="Type Text" :class="{'bg-white':formOperationalActivity.podStsMv}" :disabled="!formOperationalActivity.podStsMv || $route.query?.preview"></b-form-input>
                              </b-form-group>
                            </b-col>
                            <b-col md="6">
                              <b-form-group label="Pod grab Type" label-for="pod_grab_type">
                                <v-select :disabled="$route.query?.preview" v-model="formOperationalActivity.podGrabType" label='text' :options="polGrabTypeOpt" :reduce="item => item.value"  placeholder="Select POd Grab Type" class="bg-white"></v-select>
                              </b-form-group>
                            </b-col>
                            <b-col md="6">
                              <b-form-group label="Pod Fc Name" label-for="pod_fc_name" class="text-truncate" v-if="formOperationalActivity.podGrabType == 'gearless'">
                                <b-form-input v-model="formOperationalActivity.podFcName" :class="{'bg-white' : formOperationalActivity.podGrabType == 'gearless'}" :disabled="formOperationalActivity.podGrabType !== 'gearless' || $route.query?.preview" type="text" id="pol_mv_name" placeholder="Type Text"></b-form-input>
                              </b-form-group>
                            </b-col>
                            <b-col md="6" class="mb-2">
                              <b-form-group label="Arrival Time POD" label-for="arrival_time_pod" class="text-truncate">
                                <date-picker :disabled="$route.query?.preview" @change="validationTime(currentValidTime, formOperationalActivity.podArrivalTime)"  class="custom-date-picker" v-model="formOperationalActivity.podArrivalTime" value-type="DD-MM-YYYY HH:mm" type="datetime" placeholder="Select date" format="DD-MM-YYYY HH:mm"></date-picker>
                              </b-form-group>
                            </b-col>
                            <b-col md="6" class="mb-2"> 
                              <b-form-group label="NOR" label-for="nor" class="text-truncate mb-0">
                                <date-picker :disabled="$route.query?.preview" v-model="formOperationalActivity.podNor" class="custom-date-picker" value-type="DD-MM-YYYY HH:mm" type="datetime" placeholder="Select date" format="DD-MM-YYYY HH:mm"></date-picker>
                              </b-form-group>
                            </b-col>
                            <b-col md="6" class="mb-2"> 
                              <b-form-group label="NOA" label-for="noa" class="text-truncate mb-0">
                                <date-picker :disabled="$route.query?.preview" v-model="formOperationalActivity.podNoa" class="custom-date-picker" value-type="DD-MM-YYYY HH:mm" type="datetime" placeholder="Select date" format="DD-MM-YYYY HH:mm"></date-picker>
                              </b-form-group>
                            </b-col>
                            <b-col md="6" class="mb-2">
                              <b-form-group label="Anchor Up" label-for="podAnchorUp" class="text-truncate mb-0">
                                <date-picker :disabled="$route.query?.preview" @change="validationTime(formOperationalActivity.podArrivalTime, formOperationalActivity.podAnchorUp, 'Anchor Up', 'Arrival Time', 11)" class="custom-date-picker" v-model="formOperationalActivity.podAnchorUp" value-type="DD-MM-YYYY HH:mm" type="datetime" placeholder="Select date" format="DD-MM-YYYY HH:mm"></date-picker>
                              </b-form-group>
                              <small v-if="errorTimeText && errorTimeIndex === 11" class="text-danger" style="margin-top:-30px">*{{ errorTimeText}}</small>
                            </b-col>
                            <b-col md="6" class="mb-2">
                              <b-form-group label="In Position / Berthing" label-for="in_position_pod" class="text-truncate mb-0">
                                <date-picker :disabled="$route.query?.preview" @change="validationTime(formOperationalActivity.podAnchorUp, formOperationalActivity.podBerthing, 'Berthing', 'Anchor Up', 12)" class="custom-date-picker" v-model="formOperationalActivity.podBerthing" value-type="DD-MM-YYYY HH:mm" type="datetime" placeholder="Select date" format="DD-MM-YYYY HH:mm"></date-picker>
                              </b-form-group>
                              <small v-if="errorTimeText && errorTimeIndex === 12" class="text-danger" style="margin-top:-30px">*{{ errorTimeText}}</small>
                            </b-col>
                            <b-col md="6" class="mb-2">
                              <b-form-group label="Commenced" label-for="commenced_pod" class="text-truncate mb-0">
                                <date-picker :disabled="$route.query?.preview" @change="validationTime(formOperationalActivity.podBerthing, formOperationalActivity.podCommenced, 'Commenced', 'Berthing', 13)" class="custom-date-picker" v-model="formOperationalActivity.podCommenced" value-type="DD-MM-YYYY HH:mm" type="datetime" placeholder="Select date" format="DD-MM-YYYY HH:mm"></date-picker>
                              </b-form-group>
                              <small v-if="errorTimeText && errorTimeIndex === 13" class="text-danger" style="margin-top:-30px">*{{ errorTimeText}}</small>
                            </b-col>
                            <b-col md="6" class="mb-2">
                              <b-form-group label="Completed" label-for="completed_pod" class="text-truncate mb-0">
                                <date-picker :disabled="$route.query?.preview" @change="validationTime(formOperationalActivity.podCommenced, formOperationalActivity.podCompleted, 'Completed', 'Commenced', 14)" class="custom-date-picker" v-model="formOperationalActivity.podCompleted" value-type="DD-MM-YYYY HH:mm" type="datetime" placeholder="Select date" format="DD-MM-YYYY HH:mm"></date-picker>
                              </b-form-group>
                              <small v-if="errorTimeText && errorTimeIndex === 14" class="text-danger" style="margin-top:-30px">*{{ errorTimeText}}</small>
                            </b-col>
                            <b-col md="6">
                              <b-form-group label="Draught Survey" label-for="podDraughtSurvey" class="text-truncate mb-0">
                                 <InputCurrency
                                  prepend=""
                                  v-model="formOperationalActivity.podDraughtSurvey"
                                  :disabled="$route.query?.preview"
                                  placeholder="Type Number"
                                />
                              </b-form-group>
                            </b-col>
                            <b-col md="6" class="mb-2"> 
                              <b-form-group label="Second Berthing" label-for="polCastIn" class="text-truncate mb-0">
                                <date-picker :disabled="$route.query?.preview" v-model="formOperationalActivity.podCastIn" class="custom-date-picker" value-type="DD-MM-YYYY HH:mm" type="datetime" placeholder="Select date" format="DD-MM-YYYY HH:mm"></date-picker>
                              </b-form-group>
                              <small v-if="errorTimeText && errorTimeIndex === 5" class="text-danger" style="margin-top:-30px">*{{ errorTimeText}}</small>
                            </b-col>
                            <b-col md="6" class="mb-2">
                              <b-form-group label="Cast Out" label-for="podCastOut" class="text-truncate mb-0">
                                <date-picker :disabled="$route.query?.preview" @change="validationTime(formOperationalActivity.podCompleted, formOperationalActivity.podCastOut, 'Cast Out', 'Completed', 15)" class="custom-date-picker" v-model="formOperationalActivity.podCastOut" value-type="DD-MM-YYYY HH:mm" type="datetime" placeholder="Select date" format="DD-MM-YYYY HH:mm"></date-picker>
                              </b-form-group>
                              <small v-if="errorTimeText && errorTimeIndex === 15" class="text-danger" style="margin-top:-30px">*{{ errorTimeText}}</small>
                            </b-col>
                            <b-col md="6" class="mb-2"  v-if="showDocumentOnBoard">
                              <b-form-group label="Document On Board POD" label-for="document_on_board_pod" class="text-truncate mb-0">
                                <date-picker :disabled="$route.query?.preview" @change="validationTime(formOperationalActivity.podLhv, formOperationalActivity.podDocOnBoard, 'Doc on Board', 'LHV', 7)" class="custom-date-picker" v-model="formOperationalActivity.podDocOnBoard" value-type="DD-MM-YYYY HH:mm" type="datetime" placeholder="Select date" format="DD-MM-YYYY HH:mm"></date-picker>
                              </b-form-group>
                              <small v-if="errorTimeText && errorTimeIndex === 7" class="text-danger" style="margin-top:-30px">*{{ errorTimeText}}</small>
                            </b-col>
                            <b-col md="6" class="mb-2">
                              <b-form-group label="Departure to POL" label-for="podDeparture" class="text-truncate mb-0">
                                <date-picker :disabled="$route.query?.preview" class="custom-date-picker" v-model="formOperationalActivity.podDeparture" value-type="DD-MM-YYYY HH:mm" type="datetime" placeholder="Select date" format="DD-MM-YYYY HH:mm"></date-picker>
                              </b-form-group>
                              <small v-if="errorTimeText && errorTimeIndex === 18" class="text-danger" style="margin-top:-30px">*{{ errorTimeText}}</small>
                            </b-col>
                             <b-col md="12" class="mb-2"> 
                              <b-form-group label="Remarks" label-for="polCastIn" class="text-truncate mb-0">
                                <b-form-textarea  :disabled="$route.query?.preview"placeholder="Type Text..."  v-model="formOperationalActivity.podRemark" class="bg-white">
                                </b-form-textarea>
                              </b-form-group>
                            </b-col>
                          </b-form-row>
                        </fieldset>
                      </b-col>
                      <b-col md="12">
                        <hr>
                      </b-col>
                      <b-col md="6">
                        <fieldset class="form-group border p-3 iq-bg-info">
                          <legend class="w-auto px-2 text-primary h6"><strong>PROCESS ACTIVITY</strong></legend>
                          <template>
                            <b-form-group label="Current Activity *" label-for="reason">
                              <v-select 
                                :disabled="$route.query?.preview"
                                v-model="formOperationalActivity.reasonId" 
                                label="text" :options="reasonList" 
                                :reduce="reasonList => (reasonList.value+'|'+reasonList.text)" 
                                placeholder="Select Current Activity"
                                class="bg-white"
                                @input="handleChangeReason"
                              ></v-select>
                            </b-form-group>
                            <b-form-row class="mb-3" v-if="formOperationalActivity.reasonId && formOperationalActivity.reasonId.split('|')[1] === 'Loading'">
                              <b-col>
                                <b-form-group label="Cargo Type *" label-for="cargo_type" v-if="formOperationalActivity.reasonId.split('|')[1] === 'Loading'">
                                  <v-select :disabled="$route.query?.preview" v-model="formOperationalActivity.cargoType" label="text" :options="optionsCargoType" :reduce="cargoOptions => cargoOptions.value" placeholder="Select Type of Cargo" class="bg-white" @input="handleCargoTypeChange"></v-select>
                                </b-form-group> 
                              </b-col>
                              <b-col  v-if="formOperationalActivity.reasonId.split('|')[1] === 'Loading'">
                                <b-form-group label="Cargo Unit" label-for="polCargoUnit">
                                  <b-form-select
                                    id="polCargoUnit"
                                    plain
                                    size="md"
                                    v-model="formOperationalActivity.polCargoUnit"
                                    :options="optionsUnit"
                                    :disabled="$route.query?.preview"
                                    class="bg-white"
                                  >
                                    <template v-slot:first>
                                      <b-form-select-option :value="null">Select....</b-form-select-option>
                                    </template>
                                  </b-form-select>
                                </b-form-group>
                              </b-col> 
                            </b-form-row>
                            <b-form-row class="mb-3" v-if="formOperationalActivity.reasonId && formOperationalActivity.reasonId.split('|')[1] === 'Loading'">
                              <b-col>
                                <!-- <b-form-group label="Cargo Loading *" label-for="cargo_loading" class="d-flex flex-column"> -->
                                  <!-- <b-input-group size="md" :append="formOperationalActivity.polCargoUnit || 'N/A'">
                                    <b-form-input :disabled="$route.query?.preview" type="number" step="0.0001" class="bg-white" v-model="formOperationalActivity.cargoLoading"></b-form-input>
                                  </b-input-group> -->
                                  <!-- <span class="text-black">{{ formOperationalActivity?.cargoLoading ? Number(formOperationalActivity?.cargoLoading).toLocaleString() : 0 }} {{ formOperationalActivity.polCargoUnit }}</span>
                                  <br />
                                  <small class="text-warning" style="float: left"><i class="fa fa-warning"></i> Type Number</small>
                                </b-form-group> -->
                                <label>Cargo Loading *</label>
                                <InputCurrency
                                :append="formOperationalActivity.polCargoUnit || 'N/A'"
                                  prepend=""
                                  v-model="formOperationalActivity.cargoLoading"
                                  :disabled="$route.query?.preview || isEdit"
                                  placeholder="Type Number"
                                />
                              </b-col>
                            </b-form-row>
                            <b-form-row class="mb-3" v-if="formOperationalActivity.reasonId && formOperationalActivity.reasonId.split('|')[1]  === 'Unloading'">
                              <b-col>
                                <!-- <b-form-group label="Cargo Unloading *" label-for="cargo_unloading">
                                  <b-input-group size="md" append="Ton">
                                    <b-form-input :disabled="$route.query?.preview || (isEdit && formOperationalActivity.reasonId == '14|Unloading')" type="number" v-model="formOperationalActivity.cargoUnloading" class="bg-white"></b-form-input>
                                  </b-input-group>
                                  <span class="text-black">{{ formOperationalActivity?.cargoUnloading ? Number(formOperationalActivity?.cargoUnloading).toLocaleString() : 0 }} Ton</span>
                                  <br />
                                  <small class="text-warning" style="float: left"><i class="fa fa-warning"></i> Type Number</small>
                                </b-form-group> -->
                              <label>Cargo Unloading *</label>
                              <InputCurrency
                                :append="'Ton'"
                                  prepend=""
                                  v-model="formOperationalActivity.cargoUnloading"
                                  placeholder="Type Number"
                                  />
                                  <!-- :disabled="$route.query?.preview || isEdit" -->
                              </b-col>
                              <b-col>
                                <b-form-group label="Is End Trip:" label-for="kind-fleet">
                                    <b-form-checkbox :disabled="$route.query?.preview" v-model="formOperationalActivity.endOfTrip" name="check-button" switch inline :key="index">
                                      No / Yes
                                    </b-form-checkbox>
                                </b-form-group>
                              </b-col>
                            </b-form-row>
                            <b-form-group label="Remarks" label-for="remarks">
                              <b-form-textarea class="bg-white" :disabled="$route.query?.preview" id="description" rows="5" v-model="formOperationalActivity.remarks"></b-form-textarea>
                              <small style="float: left"><i class="fa fa-warning"></i> Max 500 Character</small>
                            </b-form-group>
                          </template>
                        </fieldset>
                      </b-col>
                      <b-col md="6">
                        <fieldset class="form-group border p-3 iq-bg-info ">
                          <legend class="w-auto px-2 text-primary h6"><strong>POSITION & PIC</strong></legend>
                          <!-- <b-form-row>
                            <b-col>
                              <b-form-group label="Activity For" label-for="voyage_for">
                                <template v-for="(item,index) in voyagefor">
                                  <b-form-radio inline v-model="formOperationalActivity.voyageFor" :name="item.name" :key="index" :value="item.value" :disabled="item.disabled || $route.query?.preview">{{ item.label }}</b-form-radio>
                                </template>
                              </b-form-group>
                            </b-col>
                          </b-form-row>
                          <b-form-row v-if="['others'].includes(formOperationalActivity.voyageFor)">
                            <b-col>
                              <b-form-group label="Activity For Other" label-for="voyageForOtherValue">
                                <b-form-input class="bg-white" type="text" v-model="formOperationalActivity.voyageForOtherValue" :disabled="$route.query?.preview"></b-form-input>
                              </b-form-group>
                            </b-col>
                          </b-form-row>
                          <b-form-row>
                            <b-col md="6">
                              <b-form-group label="Origin" label-for="origin">
                                <v-select 
                                  class="bg-white" 
                                  v-model="formOperationalActivity.origin"
                                  label="text" 
                                  :options="positionListTextPOL" 
                                  :reduce="positionListTextPOL => positionListTextPOL.value" 
                                  placeholder="Select..." 
                                  :disabled="$route.query?.preview"
                                  ></v-select>
                              </b-form-group>
                            </b-col>
                            <b-col v-if="['Other'].includes(formOperationalActivity.origin)" md="6">
                              <b-form-group label="Other Origin" label-for="origin">
                                <b-form-input 
                                  class="bg-white" type="text" v-model="formOperationalActivity.originOther" :disabled="$route.query?.preview"
                                ></b-form-input>
                              </b-form-group>
                            </b-col>
                            <b-col md="6">
                              <b-form-group label="Destination" label-for="destination">
                                <v-select 
                                  class="bg-white" 
                                  v-model="formOperationalActivity.destination" 
                                  label="text" 
                                  :options="positionListTextPOD" 
                                  :reduce="positionListTextPOD => positionListTextPOD.value" 
                                  placeholder="Select..." 
                                  :disabled="$route.query?.preview"
                                ></v-select>
                              </b-form-group>
                            </b-col>
                            <b-col v-if="['Other'].includes(formOperationalActivity.destination)" md="6">
                              <b-form-group label="Other Destination" label-for="destination">
                                <b-form-input 
                                  class="bg-white" 
                                  type="text" 
                                  v-model="formOperationalActivity.destinationOther" 
                                  :disabled="$route.query?.preview"
                                ></b-form-input>
                              </b-form-group>
                            </b-col>
                          </b-form-row> -->
                          <b-form-row>
                            <b-col :class="formOperationalActivity.currentPosition === 'Other' ? 'col-md-6': ''">
                              <b-form-group label="Current Position *" label-for="current_position">
                                <v-select :disabled="$route.query?.preview" class="bg-white" v-model="formOperationalActivity.currentPosition" label="text"  :options="positionListTextPOL" :reduce="positionListTextPOL => positionListTextPOL.value" placeholder="Select Position"></v-select>
                              </b-form-group>
                            </b-col>
                            <b-col v-if="formOperationalActivity.currentPosition === 'Other'">
                              <b-form-group label="Other Position " label-for="other_position">
                                <b-form-input class="bg-white" :disabled="$route.query?.preview" type="text" v-model="formOperationalActivity.currentPositionOther"></b-form-input>
                              </b-form-group>
                            </b-col>
                            <b-col md="12">
                              <b-form-group label="PIC / PE *" label-for="pic">
                                <v-select :disabled="$route.query?.preview" v-model="picSelected" class="bg-white" label="text" :options="picList" :reduce="picList => picList.value" placeholder="Select PIC" :multiple="true"></v-select>
                              </b-form-group>
                            </b-col>
                          </b-form-row>
                          <b-form-row>
                          </b-form-row>
                        </fieldset>
                        <b-card-text style="margin-top:-18px"><small class="text-muted">Sign * : <b-badge variant="warning">Mandatory (Must be Input)</b-badge></small></b-card-text>
                        <!-- <fieldset class="form-group border p-3 iq-bg-info mt-4">
                          <legend class="w-auto px-2 text-primary h6"><strong>PIC</strong></legend>
                          <b-form-row v-if="showPIC">
                            <b-col>
                              <b-form-group label="PIC / PE *" label-for="pic">
                                <v-select :disabled="$route.query?.preview" v-model="picSelected" class="bg-white" label="text" :options="picList" :reduce="picList => picList.value" placeholder="Select PIC" :multiple="true"></v-select>
                              </b-form-group>
                            </b-col>
                          </b-form-row>
                        </fieldset>
                        <b-card-text style="margin-top:-18px"><small class="text-muted">Sign * : <b-badge variant="warning">Mandatory (Must be Input)</b-badge></small></b-card-text> -->
                      </b-col>
                      <b-col md="6" />
                      <b-col md="12">
                        <hr>
                      </b-col>
                    </b-row>
                  </b-col>

                  <!-- NON TRIP ACTIVITY DATA FORM -->
                  <b-col md="12" v-if="formOperationalActivity.activityType === 'non trip'">
                    <b-row>
                      <b-col md="12">
                        <fieldset class="form-group border p-3 iq-bg-info">
                          <legend class="w-auto px-2 text-primary h6"><strong>PROJECT RECORD</strong></legend>
                          <b-form>
                            <b-form-group label="Project *" label-for="project">
                              <v-select 
                                v-model="formOperationalActivity.subProjectId" 
                                :options="projectOptions" 
                                :reduce="option => option.value" 
                                placeholder="Select one" 
                                track-by="value" 
                                label="text" 
                                :disabled="$route.query?.preview"
                                @input="handleChangeProject"
                                class="bg-white"
                                required
                              />
                            </b-form-group>
                          </b-form>
                        </fieldset>
                      </b-col>
                      <b-col md="12">
                        <hr>
                      </b-col>
                      <b-col md="6">
                        <fieldset class="form-group border p-3 iq-bg-info">
                          <legend class="w-auto px-2 text-primary h6"><strong>PROCESS ACTIVITY</strong></legend>
                          <template>
                            <b-form-group label="Current Activity *" label-for="reason">
                              <v-select 
                                :disabled="$route.query?.preview" 
                                v-model="formOperationalActivity.reasonId" 
                                label="text" :options="reasonList" 
                                :reduce="reasonList => (reasonList.value+'|'+reasonList.text)" 
                                placeholder="Select Current Activity"
                                class="bg-white"
                                @input="handleChangeReason"
                              ></v-select>
                            </b-form-group>
                            <b-form-row class="mb-3" v-if="formOperationalActivity.reasonId && formOperationalActivity.reasonId.split('|')[1] === 'Loading'">
                              <b-col>
                                <b-form-group label="Cargo Type *" label-for="cargo_type" v-if="formOperationalActivity.reasonId.split('|')[1] === 'Loading'">
                                  <v-select :disabled="$route.query?.preview" v-model="formOperationalActivity.cargoType" label="text" :options="optionsCargoType" :reduce="cargoOptions => cargoOptions.value" placeholder="Select Type of Cargo"></v-select>
                                </b-form-group> 
                              </b-col>
                              <b-col  v-if="formOperationalActivity.reasonId.split('|')[1] === 'Loading'">
                                <b-form-group label="Cargo Unit" label-for="polCargoUnit">
                                  <b-form-select
                                    id="polCargoUnit"
                                    plain
                                    size="md"
                                    v-model="formOperationalActivity.polCargoUnit"
                                    :options="optionsUnit"
                                    :disabled="$route.query?.preview"
                                  >
                                    <template v-slot:first>
                                      <b-form-select-option :value="null">Select....</b-form-select-option>
                                    </template>
                                  </b-form-select>
                                </b-form-group>
                              </b-col> 
                            </b-form-row>
                            <b-form-row class="mb-3" v-if="formOperationalActivity.reasonId && formOperationalActivity.reasonId.split('|')[1] === 'Loading'">
                              <b-col>
                                <b-form-group label="Cargo Loading *" label-for="cargo_loading" class="d-flex flex-column">
                                  <b-input-group size="md" :append="formOperationalActivity.polCargoUnit || 'N/A'">
                                    <b-form-input :disabled="$route.query?.preview" type="number" step="0.0001" v-model="formOperationalActivity.cargoLoading"></b-form-input>
                                  </b-input-group>
                                  <span class="text-black">{{ formOperationalActivity?.cargoLoading ? Number(formOperationalActivity?.cargoLoading).toLocaleString() : 0 }} {{ formOperationalActivity.polCargoUnit }}</span>
                                  <br />
                                  <small class="text-warning" style="float: left"><i class="fa fa-warning"></i> Type Number</small>
                                </b-form-group>
                              </b-col>
                            </b-form-row>
                            <b-form-row class="mb-3" v-if="formOperationalActivity.reasonId && formOperationalActivity.reasonId.split('|')[1]  === 'Unloading'">
                              <b-col>
                                <b-form-group label="Cargo Unloading *" label-for="cargo_unloading">
                                  <b-input-group size="md" append="Ton">
                                    <b-form-input :disabled="$route.query?.preview" type="number" v-model="formOperationalActivity.cargoUnloading"></b-form-input>
                                  </b-input-group>
                                  <span class="text-black">{{ formOperationalActivity?.cargoUnloading ? Number(formOperationalActivity?.cargoUnloading).toLocaleString() : 0 }} Ton</span>
                                  <br />
                                  <small class="text-warning" style="float: left"><i class="fa fa-warning"></i> Type Number</small>
                                </b-form-group>
                              </b-col>
                              <b-col>
                                <b-form-group label="Is End Trip:" label-for="kind-fleet">
                                    <b-form-checkbox :disabled="$route.query?.preview" v-model="formOperationalActivity.endOfTrip" name="check-button" switch inline :key="index">
                                      No / Yes
                                    </b-form-checkbox>
                                </b-form-group>
                              </b-col>
                            </b-form-row>
                            <b-form-group label="Remarks" label-for="remarks">
                              <b-form-textarea class="bg-white" :disabled="$route.query?.preview" id="description" rows="5" v-model="formOperationalActivity.remarks"></b-form-textarea>
                              <small style="float: left"><i class="fa fa-warning"></i> Max 500 Character</small>
                            </b-form-group>
                          </template>
                        </fieldset>
                      </b-col>
                      <b-col md="6">
                        <fieldset class="form-group border p-3 iq-bg-info">
                          <legend class="w-auto px-2 text-primary h6"><strong>POSITION & PIC</strong></legend>
                          <b-form-row>
                            <b-col :class="formOperationalActivity.currentPosition === 'Other' ? 'col-md-6': ''">
                              <b-form-group label="Current Position *" label-for="current_position">
                                <v-select :disabled="$route.query?.preview" class="bg-white" v-model="formOperationalActivity.currentPosition" label="text"  :options="positionListTextPOL" :reduce="positionListTextPOL => positionListTextPOL.value" placeholder="Select Position"></v-select>
                              </b-form-group>
                            </b-col>
                            <b-col v-if="formOperationalActivity.currentPosition === 'Other'">
                              <b-form-group label="Other Position " label-for="other_position">
                                <b-form-input class="bg-white" :disabled="$route.query?.preview" type="text" v-model="formOperationalActivity.currentPositionOther"></b-form-input>
                              </b-form-group>
                            </b-col>
                            <b-col md="12">
                              <b-form-group label="PIC / PE *" label-for="pic">
                                <v-select :disabled="$route.query?.preview" v-model="picSelected" class="bg-white" label="text" :options="picList" :reduce="picList => picList.value" placeholder="Select PIC" :multiple="true"></v-select>
                              </b-form-group>
                            </b-col>
                          </b-form-row>
                          <b-form-row>
                          </b-form-row>
                        </fieldset>
                        <b-card-text style="margin-top:-18px"><small class="text-muted mb-3">Sign * : <b-badge variant="warning">Mandatory (Must be Input)</b-badge></small></b-card-text>
                        <!-- <fieldset class="form-group border p-3 iq-bg-info">
                          <legend class="w-auto px-2 text-primary h6"><strong>PIC</strong></legend>
                          <template v-if="showLatitude || showLongtitude">
                            <template v-if="showLatitude">
                              <b-alert :show="true" variant=" " class="text-white bg-info"><strong>LATITUDE DMS</strong></b-alert>
                              <b-form-row class="mb-0">
                                <b-col>
                                  <b-form-group label="Degrees *" label-for="gps">
                                    <b-input-group size="md" append="°">
                                      <b-form-input :disabled="$route.query?.preview" type="number" placeholder="Degrees" v-model="dmsLat.degrees" class="bg-white"></b-form-input>
                                    </b-input-group>
                                  </b-form-group>
                                </b-col>
                                <b-col>
                                  <b-form-group label="Minutes *" label-for="gps">
                                    <b-input-group size="md" append="'">
                                      <b-form-input :disabled="$route.query?.preview" type="number" placeholder="Minutes" v-model="dmsLat.minutes" class="bg-white"></b-form-input>
                                    </b-input-group>
                                  </b-form-group>
                                </b-col>
                                <b-col>
                                  <b-form-group label="Seconds *" label-for="gps">
                                    <b-input-group size="md" append='"'>
                                      <b-form-input :disabled="$route.query?.preview" type="number" placeholder="Seconds" v-model="dmsLat.seconds" class="bg-white"></b-form-input>
                                    </b-input-group>
                                  </b-form-group>
                                </b-col>
                                <b-col>
                                  <b-form-group label="Directions" label-for="gps">
                                    <b-form-select :disabled="$route.query?.preview" v-model="dmsLat.directions" size="md" class="bg-white">
                                      <b-form-select-option>Please select an option</b-form-select-option>
                                      <b-form-select-option value="N">N</b-form-select-option>
                                      <b-form-select-option value="S">S</b-form-select-option>
                                    </b-form-select>
                                  </b-form-group>
                                </b-col>
                              </b-form-row>
                            </template>
                            <template v-if="showLongtitude">
                              <b-alert :show="true" variant=" " class="text-white bg-info"><strong>LONGITUDE DMS</strong></b-alert>
                              <b-form-row class="mb-0">
                                <b-col>
                                  <b-form-group label="Degrees *" label-for="gps">
                                    <b-input-group size="md" append="°">
                                      <b-form-input :disabled="$route.query?.preview" type="number" placeholder="Degrees" v-model="dmsLon.degrees" class="bg-white"></b-form-input>
                                    </b-input-group>
                                  </b-form-group>
                                </b-col>
                                <b-col>
                                  <b-form-group label="Minutes *" label-for="gps">
                                    <b-input-group size="md" append="'">
                                      <b-form-input :disabled="$route.query?.preview" type="number" placeholder="Minutes" v-model="dmsLon.minutes" class="bg-white"></b-form-input>
                                    </b-input-group>
                                  </b-form-group>
                                </b-col>
                                <b-col>
                                  <b-form-group label="Seconds *" label-for="gps">
                                    <b-input-group size="md" append='"'>
                                      <b-form-input :disabled="$route.query?.preview" type="number" placeholder="Seconds" v-model="dmsLon.seconds" class="bg-white"></b-form-input>
                                    </b-input-group>
                                  </b-form-group>
                                </b-col>
                                <b-col>
                                  <b-form-group label="Directions" label-for="gps">
                                    <b-form-select :disabled="$route.query?.preview" v-model="dmsLon.directions" size="md" class="bg-white">
                                      <b-form-select-option>Please select an option</b-form-select-option>
                                      <b-form-select-option value="E">E</b-form-select-option>
                                      <b-form-select-option value="W">W</b-form-select-option>
                                    </b-form-select>
                                  </b-form-group>
                                </b-col>
                              </b-form-row>
                            </template>
                            <b-form-row class="mb-0">
                              <b-col v-if="showLatitude">
                                <b-form-group label="GPS Latitude" label-for="gps">
                                  <b-form-input type="number" placeholder="latitude" class="bg-white" v-model="formOperationalActivity.lat" disabled></b-form-input>
                                </b-form-group>
                              </b-col>
                              <b-col v-if="showLongtitude">
                                <b-form-group label="GPS Longitude" label-for="gps">
                                  <b-form-input type="number" placeholder="longitude" class="bg-white mt-2" v-model="formOperationalActivity.lon" disabled></b-form-input>
                                </b-form-group>
                              </b-col>
                            </b-form-row>
                          </template>
                          <b-form-row class="mb-0" v-if="showSpeed">
                            <b-col>
                              <b-form-group label="Speed *" label-for="speed">
                                <b-input-group size="md" append="Knot">
                                  <b-form-input class="bg-white" :disabled="$route.query?.preview" type="number" v-model="formOperationalActivity.speed"></b-form-input>
                                </b-input-group>
                                <small style="float: left"><i class="fa fa-warning"></i> Type Number</small>
                              </b-form-group>
                            </b-col>
                          </b-form-row>
                          <b-form-row v-if="showPIC">
                            <b-col>
                              <b-form-group label="PIC / PE *" label-for="pic">
                                <v-select :disabled="$route.query?.preview" v-model="picSelected" class="bg-white" label="text" :options="picList" :reduce="picList => picList.value" placeholder="Select PIC" :multiple="true"></v-select>
                                <v-multiselect v-model="picSelected" placeholder="Choose PIC" label="name" track-by="value" :options="picList" :reduce="picList => picList.value" :multiple="true">
                                  <span slot="noResult">Category not found.</span>
                                </v-multiselect>
                                <b-form-input type="text" value="Auto Suggest Based on Login"> </b-form-input>
                              </b-form-group>
                            </b-col>
                          </b-form-row>
                        </fieldset>
                        <b-card-text style="margin-top:-18px"><small class="text-muted">Sign * : <b-badge variant="warning">Mandatory (Must be Input)</b-badge></small></b-card-text> -->
                      </b-col>
                      <!-- <b-col md="12">
                        <fieldset class="form-group border p-3 iq-bg-info">
                          <legend class="w-auto px-2 text-primary h6"><strong>ACTIVITY RECORD</strong></legend>
                          <b-form-row>
                            <b-col md="6">
                              <b-form-group label="Port of Loading" label-for="port_of_loading">
                                <v-select :disabled="$route.query?.preview" v-model="formOperationalActivity.portLoading" label="text" :options="positionListPOL" :reduce="positionListPOL => positionListPOL.value" placeholder="Select..." class="bg-white"></v-select>
                              </b-form-group>
                            </b-col>
                            <b-col v-if="['Other'].includes(formOperationalActivity.portLoading)" md="6">
                              <b-form-group label="Other POL" label-for="POL">
                                <b-form-input 
                                  class="bg-white" type="text" v-model="formOperationalActivity.portLoadingOther" :disabled="$route.query?.preview"
                                />
                              </b-form-group>
                            </b-col>
                            <b-col md="6">
                              <b-form-group label="Port of Discharge" label-for="port_of_discharge">
                                <v-select :disabled="$route.query?.preview" class="bg-white" v-model="formOperationalActivity.portDischarge" label="text" :options="positionListPOD" :reduce="positionListPOD => positionListPOD.value" placeholder="Select..."></v-select>
                              </b-form-group>
                            </b-col>
                            <b-col v-if="['Other'].includes(formOperationalActivity.portDischarge)" md="6">
                              <b-form-group label="Other POD" label-for="PODF">
                                <b-form-input 
                                  class="bg-white" type="text" v-model="formOperationalActivity.portDischargeOther" :disabled="$route.query?.preview"
                                />
                              </b-form-group>
                            </b-col>
                            <b-col md="6">
                              <b-form-group label="Agent POL" label-for="agent_pol" class="text-truncate">
                                <b-form-input :disabled="$route.query?.preview" v-model="formOperationalActivity.agentPol" type="text" id="agent_pol" placeholder="Type Text" class="bg-white"></b-form-input>
                              </b-form-group>
                            </b-col>
                          
                            <b-col md="6">
                              <b-form-group label="Agent POD" label-for="agent_pod" class="text-truncate">
                                <b-form-input :disabled="$route.query?.preview" v-model="formOperationalActivity.agentPod" type="text" id="agent_pod" placeholder="Type Text" class="bg-white" ></b-form-input>
                              </b-form-group>
                            </b-col>  
                            <b-col md="6" v-if="['Other'].includes(formOperationalActivity.portDischarge)">
                            </b-col>
                            <b-col md="6" class="mb-2">
                              <b-form-group label="ETA / Arrival" label-for="arrival_time_pod" class="text-truncate">
                                <date-picker :disabled="$route.query?.preview" class="custom-date-picker" v-model="formOperationalActivity.arrival" value-type="DD-MM-YYYY HH:mm" type="datetime" placeholder="Select date" format="DD-MM-YYYY HH:mm"></date-picker>
                              </b-form-group>
                            </b-col>
                            <b-col md="6" class="mb-2">
                              <b-form-group label="Departure" label-for="polDeparture" class="text-truncate mb-0">
                                <date-picker :disabled="$route.query?.preview" class="custom-date-picker" v-model="formOperationalActivity.departure" value-type="DD-MM-YYYY HH:mm" type="datetime" placeholder="Select date" format="DD-MM-YYYY HH:mm"></date-picker>
                              </b-form-group>
                            </b-col>
                          </b-form-row>
                        </fieldset>
                      </b-col> -->
                    </b-row>
                  </b-col>

                   <!-- OLD ACTIVITY DATA FORM -->
                  <b-col md="12" v-if="!formOperationalActivity.activityType && !formOperationalActivity?.tripId">
                    <b-row>
                      <b-col md="6">
                        <fieldset class="form-group border p-3 iq-bg-info">
                          <legend class="w-auto px-2 text-primary h6"><strong>PROJECT RECORD</strong></legend>
                          <b-form>
                            <b-form-group label="Project *" label-for="project">
                              <v-select 
                                v-model="formOperationalActivity.subProjectId" 
                                :options="projectOptions" 
                                :reduce="option => option.value" 
                                placeholder="Select one" 
                                track-by="value" 
                                label="text" 
                                :disabled="$route.query?.preview"
                                @input="handleChangeProject"
                                class="bg-white"
                                required
                              />
                            </b-form-group>
                          </b-form>
                        </fieldset>
                      </b-col>
                      <b-col md="6">
                        <fieldset class="form-group border p-3 iq-bg-info">
                          <legend class="w-auto px-2 text-primary h6"><strong>POSITION</strong></legend>
                          <b-form-row>
                            <b-col :class="formOperationalActivity.currentPosition === 'Other' ? 'col-md-6': ''">
                              <b-form-group label="Current Position *" label-for="current_position">
                                <v-select :disabled="$route.query?.preview" class="bg-white" v-model="formOperationalActivity.currentPosition" label="text"  :options="positionListTextPOL" :reduce="positionListTextPOL => positionListTextPOL.value" placeholder="Select Position"></v-select>
                              </b-form-group>
                            </b-col>
                            <b-col v-if="formOperationalActivity.currentPosition === 'Other'">
                              <b-form-group label="Other Position " label-for="other_position">
                                <b-form-input class="bg-white" :disabled="$route.query?.preview" type="text" v-model="formOperationalActivity.currentPositionOther"></b-form-input>
                              </b-form-group>
                            </b-col>
                          </b-form-row>
                          <b-form-row>
                          </b-form-row>
                        </fieldset>
                        <b-card-text style="margin-top:-18px"><small class="text-muted mb-3">Sign * : <b-badge variant="warning">Mandatory (Must be Input)</b-badge></small></b-card-text>
                        <fieldset class="form-group border p-3 iq-bg-info">
                          <legend class="w-auto px-2 text-primary h6"><strong>PIC</strong></legend>
                          <!-- <template v-if="showLatitude || showLongtitude">
                            <template v-if="showLatitude">
                              <b-alert :show="true" variant=" " class="text-white bg-info"><strong>LATITUDE DMS</strong></b-alert>
                              <b-form-row class="mb-0">
                                <b-col>
                                  <b-form-group label="Degrees *" label-for="gps">
                                    <b-input-group size="md" append="°">
                                      <b-form-input :disabled="$route.query?.preview" type="number" placeholder="Degrees" v-model="dmsLat.degrees" class="bg-white"></b-form-input>
                                    </b-input-group>
                                  </b-form-group>
                                </b-col>
                                <b-col>
                                  <b-form-group label="Minutes *" label-for="gps">
                                    <b-input-group size="md" append="'">
                                      <b-form-input :disabled="$route.query?.preview" type="number" placeholder="Minutes" v-model="dmsLat.minutes" class="bg-white"></b-form-input>
                                    </b-input-group>
                                  </b-form-group>
                                </b-col>
                                <b-col>
                                  <b-form-group label="Seconds *" label-for="gps">
                                    <b-input-group size="md" append='"'>
                                      <b-form-input :disabled="$route.query?.preview" type="number" placeholder="Seconds" v-model="dmsLat.seconds" class="bg-white"></b-form-input>
                                    </b-input-group>
                                  </b-form-group>
                                </b-col>
                                <b-col>
                                  <b-form-group label="Directions" label-for="gps">
                                    <b-form-select :disabled="$route.query?.preview" v-model="dmsLat.directions" size="md" class="bg-white">
                                      <b-form-select-option>Please select an option</b-form-select-option>
                                      <b-form-select-option value="N">N</b-form-select-option>
                                      <b-form-select-option value="S">S</b-form-select-option>
                                    </b-form-select>
                                  </b-form-group>
                                </b-col>
                              </b-form-row>
                            </template>
                            <template v-if="showLongtitude">
                              <b-alert :show="true" variant=" " class="text-white bg-info"><strong>LONGITUDE DMS</strong></b-alert>
                              <b-form-row class="mb-0">
                                <b-col>
                                  <b-form-group label="Degrees *" label-for="gps">
                                    <b-input-group size="md" append="°">
                                      <b-form-input :disabled="$route.query?.preview" type="number" placeholder="Degrees" v-model="dmsLon.degrees" class="bg-white"></b-form-input>
                                    </b-input-group>
                                  </b-form-group>
                                </b-col>
                                <b-col>
                                  <b-form-group label="Minutes *" label-for="gps">
                                    <b-input-group size="md" append="'">
                                      <b-form-input :disabled="$route.query?.preview" type="number" placeholder="Minutes" v-model="dmsLon.minutes" class="bg-white"></b-form-input>
                                    </b-input-group>
                                  </b-form-group>
                                </b-col>
                                <b-col>
                                  <b-form-group label="Seconds *" label-for="gps">
                                    <b-input-group size="md" append='"'>
                                      <b-form-input :disabled="$route.query?.preview" type="number" placeholder="Seconds" v-model="dmsLon.seconds" class="bg-white"></b-form-input>
                                    </b-input-group>
                                  </b-form-group>
                                </b-col>
                                <b-col>
                                  <b-form-group label="Directions" label-for="gps">
                                    <b-form-select :disabled="$route.query?.preview" v-model="dmsLon.directions" size="md" class="bg-white">
                                      <b-form-select-option>Please select an option</b-form-select-option>
                                      <b-form-select-option value="E">E</b-form-select-option>
                                      <b-form-select-option value="W">W</b-form-select-option>
                                    </b-form-select>
                                  </b-form-group>
                                </b-col>
                              </b-form-row>
                            </template>
                            <b-form-row class="mb-0">
                              <b-col v-if="showLatitude">
                                <b-form-group label="GPS Latitude" label-for="gps">
                                  <b-form-input type="number" placeholder="latitude" class="bg-white" v-model="formOperationalActivity.lat" disabled></b-form-input>
                                </b-form-group>
                              </b-col>
                              <b-col v-if="showLongtitude">
                                <b-form-group label="GPS Longitude" label-for="gps">
                                  <b-form-input type="number" placeholder="longitude" class="bg-white mt-2" v-model="formOperationalActivity.lon" disabled></b-form-input>
                                </b-form-group>
                              </b-col>
                            </b-form-row>
                          </template>
                          <b-form-row class="mb-0" v-if="showSpeed">
                            <b-col>
                              <b-form-group label="Speed *" label-for="speed">
                                <b-input-group size="md" append="Knot">
                                  <b-form-input class="bg-white" :disabled="$route.query?.preview" type="number" v-model="formOperationalActivity.speed"></b-form-input>
                                </b-input-group>
                                <small style="float: left"><i class="fa fa-warning"></i> Type Number</small>
                              </b-form-group>
                            </b-col>
                          </b-form-row> -->
                          <b-form-row v-if="showPIC">
                            <b-col>
                              <b-form-group label="PIC / PE *" label-for="pic">
                                <v-select :disabled="$route.query?.preview" v-model="picSelected" class="bg-white" label="text" :options="picList" :reduce="picList => picList.value" placeholder="Select PIC" :multiple="true"></v-select>
                                <!-- <v-multiselect v-model="picSelected" placeholder="Choose PIC" label="name" track-by="value" :options="picList" :reduce="picList => picList.value" :multiple="true">
                                  <span slot="noResult">Category not found.</span>
                                </v-multiselect> -->
                                <!-- <b-form-input type="text" value="Auto Suggest Based on Login"> </b-form-input> -->
                              </b-form-group>
                            </b-col>
                          </b-form-row>
                        </fieldset>
                        <b-card-text style="margin-top:-18px"><small class="text-muted">Sign * : <b-badge variant="warning">Mandatory (Must be Input)</b-badge></small></b-card-text>
                      </b-col>
                      <b-col md="12">
                        <hr>
                      </b-col>
                      <b-col md="12">
                        <fieldset class="form-group border p-3 iq-bg-info">
                          <legend class="w-auto px-2 text-primary h6"><strong>ACTIVITY RECORD</strong></legend>
                          <b-form-row>
                            <b-col md="6">
                              <b-form-group label="Port of Loading" label-for="port_of_loading">
                                <v-select :disabled="$route.query?.preview" v-model="formOperationalActivity.portLoading" label="text" :options="positionListPOL" :reduce="positionListPOL => positionListPOL.value" placeholder="Select..." class="bg-white"></v-select>
                              </b-form-group>
                            </b-col>
                            <b-col v-if="['Other'].includes(formOperationalActivity.portLoading)" md="6">
                              <b-form-group label="Other POL" label-for="POL">
                                <b-form-input 
                                  class="bg-white" type="text" v-model="formOperationalActivity.portLoadingOther" :disabled="$route.query?.preview"
                                />
                              </b-form-group>
                            </b-col>
                            <b-col md="6">
                              <b-form-group label="Port of Discharge" label-for="port_of_discharge">
                                <v-select :disabled="$route.query?.preview" class="bg-white" v-model="formOperationalActivity.portDischarge" label="text" :options="positionListPOD" :reduce="positionListPOD => positionListPOD.value" placeholder="Select..."></v-select>
                              </b-form-group>
                            </b-col>
                            <b-col v-if="['Other'].includes(formOperationalActivity.portDischarge)" md="6">
                              <b-form-group label="Other POD" label-for="PODF">
                                <b-form-input 
                                  class="bg-white" type="text" v-model="formOperationalActivity.portDischargeOther" :disabled="$route.query?.preview"
                                />
                              </b-form-group>
                            </b-col>
                            <b-col md="6">
                              <b-form-group label="Agent POL" label-for="agent_pol" class="text-truncate">
                                <b-form-input :disabled="$route.query?.preview" v-model="formOperationalActivity.agentPol" type="text" id="agent_pol" placeholder="Type Text" class="bg-white"></b-form-input>
                              </b-form-group>
                            </b-col>
                          
                            <b-col md="6">
                              <b-form-group label="Agent POD" label-for="agent_pod" class="text-truncate">
                                <b-form-input :disabled="$route.query?.preview" v-model="formOperationalActivity.agentPod" type="text" id="agent_pod" placeholder="Type Text" class="bg-white" ></b-form-input>
                              </b-form-group>
                            </b-col>  
                            <b-col md="6" v-if="['Other'].includes(formOperationalActivity.portDischarge)">
                            </b-col>
                            <b-col md="6" class="mb-2">
                              <b-form-group label="ETA / Arrival" label-for="arrival_time_pod" class="text-truncate">
                                <date-picker :disabled="$route.query?.preview" class="custom-date-picker" v-model="formOperationalActivity.arrival" value-type="DD-MM-YYYY HH:mm" type="datetime" placeholder="Select date" format="DD-MM-YYYY HH:mm"></date-picker>
                              </b-form-group>
                            </b-col>
                            <b-col md="6" class="mb-2">
                              <b-form-group label="Departure" label-for="polDeparture" class="text-truncate mb-0">
                                <date-picker :disabled="$route.query?.preview" class="custom-date-picker" v-model="formOperationalActivity.departure" value-type="DD-MM-YYYY HH:mm" type="datetime" placeholder="Select date" format="DD-MM-YYYY HH:mm"></date-picker>
                              </b-form-group>
                            </b-col>
                          </b-form-row>
                        </fieldset>
                      </b-col>
                      <b-col md="12">
                        <hr>
                      </b-col>
                      <b-col md="6">
                        <fieldset class="form-group border p-3 iq-bg-info">
                          <legend class="w-auto px-2 text-primary h6"><strong>PROCESS ACTIVITY</strong></legend>
                          <template>
                            <b-form-group label="Current Activity *" label-for="reason">
                              <v-select 
                                :disabled="$route.query?.preview" 
                                v-model="formOperationalActivity.reasonId" 
                                label="text" :options="reasonList" 
                                :reduce="reasonList => (reasonList.value+'|'+reasonList.text)" 
                                placeholder="Select Current Activity"
                                class="bg-white"
                                @input="handleChangeReason"
                              ></v-select>
                            </b-form-group>
                            <b-form-row class="mb-3" v-if="formOperationalActivity.reasonId && formOperationalActivity.reasonId.split('|')[1] === 'Loading'">
                              <b-col>
                                <b-form-group label="Cargo Type *" label-for="cargo_type" v-if="formOperationalActivity.reasonId.split('|')[1] === 'Loading'">
                                  <v-select :disabled="$route.query?.preview" v-model="formOperationalActivity.cargoType" label="text" :options="optionsCargoType" :reduce="cargoOptions => cargoOptions.value" placeholder="Select Type of Cargo"></v-select>
                                </b-form-group> 
                              </b-col>
                              <b-col  v-if="formOperationalActivity.reasonId.split('|')[1] === 'Loading'">
                                <b-form-group label="Cargo Unit" label-for="polCargoUnit">
                                  <b-form-select
                                    id="polCargoUnit"
                                    plain
                                    size="md"
                                    v-model="formOperationalActivity.polCargoUnit"
                                    :options="optionsUnit"
                                    :disabled="$route.query?.preview"
                                  >
                                    <template v-slot:first>
                                      <b-form-select-option :value="null">Select....</b-form-select-option>
                                    </template>
                                  </b-form-select>
                                </b-form-group>
                              </b-col> 
                            </b-form-row>
                            <b-form-row class="mb-3" v-if="formOperationalActivity.reasonId && formOperationalActivity.reasonId.split('|')[1] === 'Loading'">
                              <b-col>
                                <b-form-group label="Cargo Loading *" label-for="cargo_loading" class="d-flex flex-column">
                                  <b-input-group size="md" :append="formOperationalActivity.polCargoUnit || 'N/A'">
                                    <b-form-input :disabled="$route.query?.preview" type="number" step="0.0001" v-model="formOperationalActivity.cargoLoading"></b-form-input>
                                  </b-input-group>
                                  <span class="text-black">{{ formOperationalActivity?.cargoLoading ? Number(formOperationalActivity?.cargoLoading).toLocaleString() : 0 }} {{ formOperationalActivity.polCargoUnit }}</span>
                                  <br />
                                  <small class="text-warning" style="float: left"><i class="fa fa-warning"></i> Type Number</small>
                                </b-form-group>
                              </b-col>
                            </b-form-row>
                            <b-form-row class="mb-3" v-if="formOperationalActivity.reasonId && formOperationalActivity.reasonId.split('|')[1]  === 'Unloading'">
                              <b-col>
                                <b-form-group label="Cargo Unloading *" label-for="cargo_unloading">
                                  <b-input-group size="md" append="Ton">
                                    <b-form-input  type="number" v-model="formOperationalActivity.cargoUnloading"></b-form-input>
                                  </b-input-group>
                                  <span class="text-black">{{ formOperationalActivity?.cargoUnloading ? Number(formOperationalActivity?.cargoUnloading).toLocaleString() : 0 }} Ton</span>
                                  <br />
                                  <small class="text-warning" style="float: left"><i class="fa fa-warning"></i> Type Number</small>
                                </b-form-group>
                              </b-col>
                              <b-col>
                                <b-form-group label="Is End Trip:" label-for="kind-fleet">
                                    <b-form-checkbox :disabled="$route.query?.preview" v-model="formOperationalActivity.endOfTrip" name="check-button" switch inline :key="index">
                                      No / Yes
                                    </b-form-checkbox>
                                </b-form-group>
                              </b-col>
                            </b-form-row>
                            <b-form-group label="Remarks" label-for="remarks">
                              <b-form-textarea class="bg-white" :disabled="$route.query?.preview" id="description" rows="5" v-model="formOperationalActivity.remarks"></b-form-textarea>
                              <small style="float: left"><i class="fa fa-warning"></i> Max 500 Character</small>
                            </b-form-group>
                          </template>
                        </fieldset>
                      </b-col>
                    </b-row>
                  </b-col>
                </template>
              </b-col>
               <!-- Last Operational -->
              <b-col cols="4" class="h-auto" md="4" v-if="!$route?.query?.preview || $route?.query?.preview === false">
                <h5 class="card-title text-primary mb-4"><strong>LAST OPERATIONAL</strong></h5>
                  <div class="m-0 px-3 overflow-auto" :style="{height:timeLineHeigth + 'px',background:'#F6F2F8'}">
                    <div v-for="each in activityList" :key="each.id" class="py-3" style="border-bottom:1px solid">
                      <b-row class="m-0 p-0">
                        <b-col md="11" class="border-b m-0 p-0">
                          <h6 class="float-left text-dark">
                            {{ each?.startDate ? moment(each?.startDate, 'DD-MM-YYYY HH:mm').format('DD MMM YYYY HH:mm') : '-' }} - {{ each?.endDate ? moment(each?.endDate, 'DD-MM-YYYY HH:mm').format('DD MMM YYYY HH:mm') : '-' }}</h6>
                          <div class="d-inline-block w-100 text-black text-truncate">
                            <!-- <b-badge variant="danger">Market : 2 Hours | 42 Minutes</b-badge> -->
                            <b-badge variant="info" class="mb-2">
                              <i class="fa fa-clock"></i>
                              {{each.activityDurationFormat}}
                            </b-badge>
                            <div class="d-flex align-items-center mb-3" v-if="each.vehicle.length > 0">
                              <div v-for="(fleet, fleetIdx) in each.vehicle" :key="fleetIdx" class="d-flex align-items-center">
                                <template>
                                  <b-badge variant="success">{{fleet?.name}}</b-badge>
                                  <LinkIcon class="mx-2" v-if="fleetIdx !== each.vehicle.length - 1" />
                                </template>
                              </div>
                            </div>
                            <div class="flex align-items-center text-primary mb-2 font-semibold" v-if="(each.polTrip && each.podTrip) && each?.activityType === 'trip'">
                              <!-- <i class="fa fa-map-marker mr-1"></i> -->
                               <MapPinOutline class="mr-1"/>
                               <span>{{each.polTrip}}</span>
                               <i class="fas fa-arrow-right mx-2"></i>
                               <MapPinOutline class="mr-1"/>
                              <!-- <i class="fa fa-map-marker mr-1"></i> -->
                              <span>{{each.podTrip}}</span>
                            </div>
                            <div v-if="(!each.polTrip && !each.podTrip) && each?.activityType === 'trip'" class="d-flex align-items-center text-danger">
                              <i class="ri-close-circle-line mr-2"></i>
                                Not Setup Trip
                            </div>
                            <div v-if="each?.activityType === 'non trip'" class="d-flex align-items-center text-danger">
                              <i class="ri-close-circle-line mr-2"></i>
                                Non Trip
                            </div>
                            <div v-if="!each?.activityType" class="d-flex align-items-center text-danger">
                              <i class="ri-close-circle-line mr-2"></i>
                                Not Available
                            </div>
                            <p class="mb-0" v-if="!each?.cargo">{{each.activityName}}</p>
                            <p class="mb-0" v-else>{{each.activityName}}: <strong>{{Number(each?.cargo)?.toLocaleString()}}</strong></p>
                          </div>
                        </b-col>
                        <b-col md="1" class="p-0 m-0">
                          <b-dropdown variant="link iq-bg-primary iq-border-radius-10" toggle-class="text-decoration-none" no-caret>
                            <template v-slot:button-content>
                              <span class="dropdown-toggle p-0" id="dropdownMenuButton5" data-toggle="dropdown">
                              <!-- <i class="fa fa-caret-down m-0 text-primary"></i> -->
                              </span>
                            </template>
                            <b-dropdown-item href="#" class="m-0 p-0" @click="() => {getActivityDetail(each.id, true); locked = true}"><i class="fa fa-pencil-square-o mr-2"></i>Edit</b-dropdown-item>
                            <b-dropdown-item href="#" class="m-0 p-0" @click="onDeleteActivity(each)" v-if="each.activityName !== 'Finish'"><i class="fa fa-trash mr-2"></i>Delete</b-dropdown-item>
                          </b-dropdown>
                        </b-col>
                      </b-row>
                    </div>
                </div>
              </b-col>

              <template v-if="!loadingOperational">
                <!-- SHELTER -->
                <b-col md="12" v-if="(nextStep && !loadingOperational && !isActivityId ) || (isActivityId && !loadingOperational)">
                  <b-form-checkbox name="check-button" class="mb-3" switch v-model="useShelter" :disabled="$route.query?.preview" @change="handleUseShelter">Use Shelter?
                  </b-form-checkbox>
                  <fieldset class="form-group border p-3 iq-bg-warning" v-if="useShelter">
                    <legend class="w-auto px-2 text-danger h6"><strong>SHELTER</strong></legend>
                    <b-row>
                      <b-col md="12">
                        <div class='d-flex justify-content-end w-100 m-0'>
                          <b-button class="mb-2" variant="primary" type="button" @click="addShelter">Add Shelter <i class="fa fa-plus" /></b-button>
                        </div>
                        <b-col md="12">
                          <div class="d-flex w-100 border mb-2" />
                        </b-col>
                        <b-row v-for="(val, index) in formOperationalActivity.shelter" :key="index">
                          <b-col md="2">
                            <b-form-group label="Shelter For" label-for="shelter_for"> 
                              <b-form-select v-model="val.shelterFor" :disabled="$route.query?.preview" plain size="sm" style="background-color:#ffffff;">
                                <template v-slot:first>
                                  <b-form-select-option :value="''">Select...</b-form-select-option>
                                  <b-form-select-option :value="'loading'">Loading</b-form-select-option>
                                  <b-form-select-option :value="'discharge'">Discharge</b-form-select-option>
                                  <b-form-select-option :value="'others'">Others</b-form-select-option>
                                </template>
                              </b-form-select>
                            </b-form-group> 
                          </b-col>
                          <b-col md="2" v-if="['others'].includes(val.shelterFor)">
                            <b-form-group label="Shelter For Other" label-for="shelterForOther">
                              <b-form-input class="bg-white" type="text" v-model="val.shelterForOtherValue" :disabled="$route.query?.preview"></b-form-input>
                            </b-form-group>
                          </b-col>
                          <b-col :md="['Other'].includes(val.shelterLocation) ? '4' : '2'">
                            <b-form-group label="Shelter Location" label-for="shelter_location"> 
                              <div class="d-flex">
                                <v-select 
                                  v-model="val.shelterLocation" 
                                  label="text" 
                                  :options="positionListTextPOL" 
                                  :reduce="positionListTextPOL => positionListTextPOL.value" 
                                  placeholder="Select..." 
                                  style="background-color:#ffffff; width:200px"
                                  class="mr-2"
                                  :disabled="$route.query?.preview"
                                />
                                <b-form-input
                                  v-if="['Other'].includes(val.shelterLocation)"
                                  type="text" v-model="val.shelterLocationOther"
                                  style="background-color:#ffffff; width:200px"
                                  placeholder="Other shelter..."
                                  :disabled="$route.query?.preview"
                                />
                              </div>
                            </b-form-group> 
                          </b-col> 
                          <b-col :md="['Other'].includes(val.destination) ? '4' : '2'">
                            <b-form-group label="Destination" label-for="destination"> 
                              <div class="d-flex">
                                <v-select 
                                  v-model="val.destination" 
                                  label="text" 
                                  :options="positionListTextPOD"
                                  :reduce="positionListTextPOD => positionListTextPOD.value" 
                                  placeholder="Select..." 
                                  style="background-color:#ffffff; width:200px"
                                  class="mr-2"
                                  :disabled="$route.query?.preview"
                                />
                                <b-form-input
                                  v-if="['Other'].includes(val.destination)"
                                  type="text" v-model="val.destinationOther"
                                  style="background-color:#ffffff; width:200px"
                                  placeholder="Other destination..."
                                  :disabled="$route.query?.preview"
                                />
                              </div>
                            </b-form-group> 
                          </b-col> 
                          <b-col md="2">
                            <b-form-group label="Arrival Shelter" label-for="arrival"> 
                              <date-picker 
                                v-model="val.arrivalShelter" 
                                value-type="DD-MM-YYYY HH:mm" 
                                type="datetime"
                                placeholder="Select date" 
                                format="DD-MM-YYYY HH:mm" 
                                class="custom-date-picker"
                                :disabled="$route.query?.preview"
                              />
                            </b-form-group> 
                          </b-col> 
                          <b-col md="2">
                            <b-form-group label="Drop Anchor Shelter" label-for="arrival"> 
                              <date-picker 
                                v-model="val.dropAnchorShelter" 
                                value-type="DD-MM-YYYY HH:mm" 
                                type="datetime"
                                placeholder="Select date" 
                                format="DD-MM-YYYY HH:mm" 
                                class="custom-date-picker"
                                :disabled="$route.query?.preview"
                              />
                            </b-form-group> 
                          </b-col> 
                          <b-col md="2">
                            <b-form-group label="Full Aways Shelter" label-for="fullaways"> 
                              <date-picker 
                                v-model="val.fullAwayShelter" 
                                value-type="DD-MM-YYYY HH:mm" 
                                type="datetime"
                                placeholder="Select date" 
                                format="DD-MM-YYYY HH:mm" 
                                class="custom-date-picker"
                                :disabled="$route.query?.preview"
                              />
                            </b-form-group> 
                          </b-col> 
                          <b-col md="4">
                            <b-form-group label="Remarks" label-for="arrival"> 
                              <b-form-textarea 
                                v-model="val.remarks"
                                name="remarks"
                                placeholder="Type Text"
                                style="background-color:#ffffff;"
                                :disabled="$route.query?.preview"
                              />
                            </b-form-group> 
                          </b-col>  
                          <b-col md="1" v-if="index !== 0">
                            <div class="d-flex align-items-center w-auto h-100 mt-1">
                              <i class="fa fa-trash text-danger text-xl" @click="formOperationalActivity.shelter.splice(index, 1)" style="cursor: pointer" />
                            </div>
                          </b-col> 
                          <b-col md="12">
                            <div class="d-flex w-100 border mb-2" />
                          </b-col>
                        </b-row>
                      </b-col>
                    </b-row>
                  </fieldset>
                </b-col>
                <b-col md="8">
                  <hr>
                </b-col>
                <b-col md="8" class="text-center mt-3" v-if="nextStep && !$route.query?.preview">
                  <div class="d-flex w-100 align-items-center">
                    <b-button type="submit" variant="primary" @click="saveActivity()" block class="w-50" :disabled="loadingSubmit">
                      <b-spinner small v-if="loadingSubmit" class="mr-1"></b-spinner>
                      <i v-else class="fa fa-save"></i> 
                      {{ loadingSubmit ? 'Submitting...' : 'Submit & Save Operational Data' }}
                    </b-button>
                    <b-button v-if="!isEdit" variant="none" class="iq-bg-danger ml-3 w-50" @click="resetForm" block :disabled="loadingSubmit"><i class="fa fa-close"></i> Reset Form Operational Data</b-button>
                    <b-button v-if="isEdit" variant="none" class="iq-bg-danger ml-3 w-50" @click="cancelEdit()" :disabled="loadingSubmit"><i class="fa fa-close"></i> Cancel Edit Operational Data</b-button>
                  </div>
                </b-col>
              </template>

              <template v-if="loadingOperational">
                <LoadingOverlayFullscreen :visible="loadingOperational" :text="'Loading data...'" />
              </template>
            </b-row>
          </template>
        </iq-card>
      </b-col>
    </b-row>
    <!-- End Top Section !-->
  </b-container>
</template>
<script>
import { xray } from '../../config/pluginInit'
import { voyagesActions, fleetsActions, projectsActions, reasonsActions, portsActions, usersActions, busdevActions } from '@src/Utils/helper'
import { required, requiredIf, sameAs, minLength, minValue } from 'vuelidate/lib/validators'
import moment from 'moment'
import LoadingOverlayFullscreen from '@src/components/LoadingOverlayFullscreen.vue'
import LinkIcon from '@src/components/svg-icon/LinkIcon.vue'
import MapPinOutline from '@src/components/svg-icon/MapPinOutline.vue'
import { singleConvertDMSToDD } from '@src/plugins/helpers'
import InputCurrency from '@/src/components/global/InputCurrency.vue'

var date = new Date()

export default {
name: 'Operational',
components:{
  LoadingOverlayFullscreen,
  LinkIcon,
  MapPinOutline,
InputCurrency
},
data () {
  return {
    isOldActivity:false,
    activityData:null,
    loadingOperational:false,
    loadingSubmit:false,

    checkedActivies:[],

    optionsUnit:[],
    optionsCargoType:[],
    // Connect with API
    useShelter: false,
    isEdit: false,
    isActivityId: '',
    fleet: {
      vehicleType: {
        name: ''
      }
    },
    fleetEdit: null,
    activityList: [],
    fleetList: [],
    dmsLat: {
      degrees: '',
      minutes: '',
      seconds: '',
      directions: 'S'
    },
    dmsLon: {
      degrees: '',
      minutes: '',
      seconds: '',
      directions: 'E'
    },
    activitiesUnfinishedTrip:null,
    formOperationalActivity: {
      startDate: new Date(date.getFullYear(), date.getMonth(), date.getDate()),
      endDate: new Date(date.getFullYear(), date.getMonth(), date.getDate()),
      vehicles: [
        {
          vehicleId: '',
          vehicleNumber: 1,
          breakdown: false
        },
        {
          vehicleId: '',
          vehicleNumber: 2,
          breakdown: false
        }
      ],
      isCrossTrip:null,
      fleetId:null,
      activityType: 'trip',
      voyageActivityType: 'UNTOWING',
      subProjectId: '',
      reasonId: '',
      cargoType: '',
      cargoLoading: '',
      cargoUnloading: '',
      remarks: '',
      currentPosition: '',
      arrival: '',
      departure: '',
      portLoading: '',
      portLoadingOther: '',
      portDischarge: '',
      portDischargeOther: '',
      agentPol: '',
      agentPod: '',
      dmsLat: '',
      dmsLon: '',
      lat: '',
      lon: '',
      speed: 1,
      pic: [JSON.parse(localStorage.getItem('profile'))?.id],
      endOfTrip: false,
      "destinationOther": "",
      "originOther": "",
      "newTrip": false,
      "polCargoUnit": "",
      "polAnchorUp": "",
      "polArrivalTime":"",
      "polBerthing":"",
      "polCommenced":"",
      "polCompleted":"",
      "polDocOnBoard":"",
      "podDocOnBoard":"",
      "docOnBoard":"", 
      "polDeparture":"",
      "polLhv":"",
      "podCargoUnit":"",
      "podAnchorUp":"",
      "podLhv":"",
      "podDeparture":"",
      "podArrivalTime":"",
      "podBerthing":"",
      "podCommenced":"",
      "podCompleted":"",

      "polBlDate":"",
      "podBlDate":"",

      "podNor":"",
      "podNoa":"",
      "podCastIn":"",
      "podCastOut":"",
      "polCastIn":"",
      "polCastOut":"",
      "polNor":"",
      "polNoa":"",
      
      "voyageFor": "loading",
      "voyageForOtherValue": "",  
      "origin": "",
      "destination": "",
      "speedBySystem": 0,
      "polDraughtSurvey": 0,
      "podDraughtSurvey": 0,
      polStsMv:false,
      polMvName:'',
      polGrabType:'gearless',
      polFcName:'',
      podStsMv:false,
      podMvName:'',
      podGrabType:'gearless',
      podFcName:'',

      "shelter": [{
        "shelterLocationOther": "", 
        "destinationOther": "", 
        "shelterFor": "", // loading, discharge, others
        "shelterLocation": "",
        "destination": "",
        "arrivalShelter": "",
        "dropAnchorShelter": "",
        "fullAwayShelter": "",
        "remarks": ""
      }]
    },
    locked: false,

    loadingForm: false,
    loadingCheck: false,
    // End Connect
    nextStep: false,
    secondFleet: '7',
    anotherFleet: '3',
    startDate: moment().format('DD-MM-YYYY HH:mm'),
    endDate: '',
    reason: null,
    moreLoading: true,
    breakdown: false,
    breakdownAnother: false,
    endMoreLoading: true,
    selectedAction: 'UNTOWING',
    action: [
      {
        label: 'Not Towing',
        color: 'default',
        value: 'UNTOWING'
      },
      {
        label: 'Towing Tug/Barge',
        color: 'primary',
        value: 'SINGLE_TOWING'
      },
      {
        label: 'Double Towing',
        color: 'warning',
        value: 'DOUBLE_TOWING'
      }
    ],
    projectValue: '',
    projectOptions: [],
    project: 2,
    timeLineHeigth: 600,
    resizeObserver:null,
    projectList: [
      { value: '1', text: 'Arutmin Project' },
      { value: '2', text: 'KPC Project' },
      { value: '3', text: 'AI Project' },
      { value: '5', text: 'Virtue Dragon Nickel Industry Project' },
      { value: '6', text: 'Pracadi Project' },
      { value: '7', text: 'Conch Project' },
      { value: '8', text: 'Tsingshan Steel Indonesia Project' }
    ],
    subProject: 1,
    subProjectList: [
      { value: '1', text: 'Transhipment' },
      { value: '2', text: 'Long Hauling' },
      { value: '3', text: 'Armada Oil Barge' },
      { value: '4', text: 'Finance' },
      { value: '5', text: 'Loading' },
      { value: '6', text: 'Unloading' }
    ],
    position: '',
    currentPositionOther: '',
    positionListPOL: [
      { value: 'Other', text: 'Other Position', portType: 'OTHERS' }
    ],  
    positionListPOD: [
      { value: 'Other', text: 'Other Position', portType: 'OTHERS' }
    ], 
    positionListTextPOL: [
      { value: 'Other', text: 'Other Position', portType: 'OTHERS' }
    ],
    positionListTextPOD: [
      { value: 'Other', text: 'Other Position', portType: 'OTHERS' }
    ],

    reasonList: [],
    portList: [
      { value: 'Asam-Asam', text: 'Asam-Asam' },
      { value: 'Sangatta', text: 'Sangatta' },
      { value: 'Paiton', text: 'Paiton' },
      { value: 'Bengalon', text: 'Bengalon' },
      { value: 'Tanjung Bara', text: 'Tanjung Bara' },
      { value: 'Tanjung Awar-Awar', text: 'Tanjung Awar-Awar' },
      { value: 'Rembang', text: 'Rembang' }
    ],

    picSelected: [],
    picList: [],
    agentPOL: 'TCP',
    agentPOD: 'SAJ',
    agentList: [
      { value: 'TCP', text: 'TCP' },
      { value: 'SAJ', text: 'SAJ' },
      { value: 'ANTAM', text: 'ANTAM' }
    ],
    typeOfCargo: 'COAL',
    typeOfCargoOther: '',
    cargoOptions: [
      { value: 'COAL', text: 'COAL' },
      { value: 'FUEL', text: 'FUEL' },
      { value: 'OIL', text: 'OIL' },
      { value: 'NICKEL', text: 'NICKEL' },
      { value: 'CRANE-CONTAINER', text: 'CRANE CONTAINER' },
      { value: 'Others', text: 'Others...' }
    ],

    voyageActive: {
      single: 'active',
      disable: 'active',
      number: 'loading',
      color: 'danger'
    },

    voyagefor: [
      {
        name: 'number',
        label: 'Loading',
        value: 'loading',
        disabled: false
      },
      {
        name: 'number',
        label: 'Discharge',
        value: 'discharge',
        disabled: false
      },
      {
        name: 'number',
        label: 'Others',
        value: 'others',
        disabled: false
      }
    ], 
    activityTypeOpt: [
      {
        name: 'trip',
        label: 'Trip',
        value: 'trip',
        disabled: false
      },
      {
        name: 'non trip',
        label: 'Non Trip',
        value: 'non trip',
        disabled: false
      },
    ], 

    polGrabTypeOpt:[
      {
        text:'Gearless',
        value:'gearless'
      },
      {
        text:'Gear and Grab',
        value:'gearless_and_grab'
      }
    ],
    
    currentValidTime: null,
    errorTimeText: '',
    errorTimeIndex: null,
    errorValidation: false,
    
    optionsFleets: [],

    unfinishedTrip: [],
    finishedTrip: [],
    
    crossTrip:false,
    crossTripList: [],
  }
},
computed: {
  isUnfinishedTripChecked(){
    let isChecked = this.unfinishedTrip.find(obj => obj.checked === true)
    return isChecked ? true : false
  },
  isCrossTripChecked(){
    let isChecked = this.crossTripList.find(obj => obj.checked === true)
    return isChecked ? true : false
  },
  vehicleId () {
    const { vehicleId } = this.$route.query

    if (!vehicleId) {
      return null
    }

    return vehicleId
  },
  vehicleIdParam () {
    return this.$route.query.vehicleId
      ? this.$route.query.vehicleId
      : ''
  },
  combineDNSLat () {
    return `${this.dmsLat.degrees}° ${this.dmsLat.minutes}' ${this.dmsLat.seconds}" ${this.dmsLat.directions}`
  },
  combineDNSLng () {
    return `${this.dmsLon.degrees}° ${this.dmsLon.minutes}' ${this.dmsLon.seconds}" ${this.dmsLon.directions}`
  },
  fleetListFiltered () {
    let currentFleetId = !this.isEdit ? this.fleet.id : this.fleetEdit.id
    return this.fleetList.filter(fleet => Number(fleet.id) !== Number(currentFleetId))
  },
  // field visibilities
  showVoyageWidth () {
    return ![3, 6].includes(this.fleet?.vehicleType?.id)
  },
  showDepartureDateTime () {
    return ![6].includes(this.fleet?.vehicleType?.id)
  },
  showArrivalDateTime () {
    return ![6].includes(this.fleet?.vehicleType?.id)
  },
  showPortOfLoading () {
    return ![6].includes(this.fleet?.vehicleType?.id)
  },
  showPortOfDischarge () {
    return ![6].includes(this.fleet?.vehicleType?.id)
  },
  showPortAgentPol () {
    return ![6].includes(this.fleet?.vehicleType?.id)
  },
  showPortAgentPod () {
    return ![6].includes(this.fleet?.vehicleType?.id)
  },
  showLatitude () {
    return ![6].includes(this.fleet?.vehicleType?.id)
  },
  showLongtitude () {
    return ![6].includes(this.fleet?.vehicleType?.id)
  },
  showSpeed () {
    return ![6].includes(this.fleet?.vehicleType?.id)
  },
  showDocumentOnBoard () {
    return ![6].includes(this.fleet?.vehicleType?.id)
  },
  showPIC () {
    return ![6].includes(this.fleet?.vehicleType?.id)
  }
},
validations () {
  let ret = {
    formOperationalActivity: {
      startDate: { required },
      endDate: { required }
    }
  }

  return ret
  /* if (this.formOperationalActivity.voyageActivityType == 'TOWING' || this.formOperationalActivity.voyageActivityType == 'DOUBLE-TOWING'){
    return {
      formOperationalActivity: {
        startDate: { required },
        endDate: { required }
      }
    }
  } else {
    return {
      formOperationalActivity: {
        startDate: { required },
        endDate: { required },
      }
    }
  } */
},
async mounted () {
  xray.index()
  this.loadingOperational = true

  await this.getCargoType()
  await this.getUnit()
  await this.fetchFleets()
  await this.fetchFleetById()
  await this.listFleet()
  await this.getProjectList()
  await this.getReasonList()
  await this.getPortListText()
  await this.getUserList()
  await this.getLastActivity()
  await this.fetchUnfinishTrip()
  if (this.$route.query.activityEditId) {
    this.getActivityDetail(this.$route.query.activityEditId, true)
  } else {
    this.initActivityForm(false)
  }

  
  this.loadingOperational = false

  this.observeHeightChanges()
},
 beforeDestroy() {
    this.unobserveHeightChanges();
  },
watch: {
  'dmsLat': {
    handler () {
      this.generateGPSLat()
    },
    deep: true
  },
  'formOperationalActivity.currentPosition'(val) {
    if (val === 'Other') {
      this.formOperationalActivity.currentPositionOther = this.formOperationalActivity.currentPositionOther ??  'Sea Passage';
    }
  },
  'dmsLon': {
    handler () {
      this.generateGPSLng()
    },
    deep: true
  },
  'formOperationalActivity.newTrip': {
    handler (newVal) {
      if(newVal){
        this.unfinishedTrip = this.unfinishedTrip?.map(val => {
          return {
            ...val,
            checked:false
          }
        })
      }
    },
    deep: true,
    immediate: true
  },
  endDate: function () {
    if (this.endDate <= this.startDate) {
      this.$swal.fire({
        icon: 'warning',
        title: 'Oops...',
        text: 'End Date tidak boleh kurang dari Start Date!'
      }).then((result) => {
        this.endDate = ''
      })
    }
  }
},
methods: {
  ...busdevActions,
  ...voyagesActions,
  ...fleetsActions,
  ...projectsActions,
  ...reasonsActions,
  ...portsActions,
  ...usersActions,

  updateLeftHeight() {
   this.$nextTick(() => {
      const timelineEl = this.$refs.leftContent;
      console.log("timelineEl", timelineEl);
      
      if (timelineEl?.offsetHeight > 600) {
       this.timeLineHeigth = timelineEl.offsetHeight
      }
    });

  },

  observeHeightChanges() {
    const config = {
      attributes: true,
      attributeFilter: ['style'],
    };
    this.resizeObserver = new ResizeObserver((mutations) => {
      console.log('mutation', mutations);
      console.log('this.$refs.leftContent.offsetHeight', this.$refs.leftContent.offsetHeights);
      mutations.forEach((mutation) => {
        // if (mutation.attributeName === 'style') {
          // this.timeLineHeigth = this.$refs.leftContent?.offsetHeight;
          this.timeLineHeigth = mutation.contentRect.height;
        // }
      });
    });
    console.log('resizeObserver', this.resizeObserver);
    
    this.resizeObserver.observe(this.$refs.leftContent, config);
    this.timeLineHeigth = this.$refs.leftContent.offsetHeight; // Set initial height
  },

  unobserveHeightChanges() {
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
    }
  },

  handleUseShelter(){
    if(this.useShelter){
      this.formOperationalActivity.shelter[0].shelterLocationOther = this.formOperationalActivity?.currentPositionOther
      this.formOperationalActivity.shelter[0].shelterFor = this.formOperationalActivity.voyageFor
      this.formOperationalActivity.shelter[0].shelterForOtherValue = this.formOperationalActivity.voyageForOtherValue
      this.formOperationalActivity.shelter[0].shelterLocation = this.formOperationalActivity.currentPosition
    }
  },
  handleChangeReason(){
    if(this.formOperationalActivity.reasonId && this.formOperationalActivity.reasonId.split('|')[1] === 'Loading'){
      this.formOperationalActivity.cargoLoading = this.formOperationalActivity.polDraughtSurvey
    } else if(this.formOperationalActivity.reasonId && this.formOperationalActivity.reasonId.split('|')[1] === 'Unloading'){
      if(this.checkedActivies?.length > 0){
        let totalUnloading = this.checkedActivies?.filter(obj => obj.cargoUnloading > 0)?.reduce((acc, obj) => acc + obj.cargoUnloading ,0)
        totalUnloading = totalUnloading || 0
        this.formOperationalActivity.cargoUnloading = Number(this.formOperationalActivity.podDraughtSurvey) - Number(totalUnloading)
      }
    } else {
      this.formOperationalActivity.cargoLoading = 0
      this.formOperationalActivity.cargoUnloading = 0
    }
  },
  handleCargoTypeChange(selectedValue) {
    // Reset cargo unit ketika cargo type berubah
    this.formOperationalActivity.polCargoUnit = null
    
    // Cari cargo type yang dipilih dari optionsCargoType
    const selectedCargoType = this.optionsCargoType.find(cargo => cargo.value === selectedValue)?.unit

    
    if (selectedCargoType && selectedCargoType.child && selectedCargoType.child.length > 0) {
      // Set optionsUnit dari child cargo type yang dipilih
      this.optionsUnit = selectedCargoType.child.map(child => ({
        text: child.name,
        value: child.alias
      }))
    } else {
      // Jika tidak ada child, kosongkan optionsUnit
      this.optionsUnit = []
    }
  },
  saveDraft(){
    localStorage.setItem('formOperationalActivity', JSON.stringify(this.formOperationalActivity));
    this.$swal('Saved.', 'Data Activity Saved.', 'success')
  },
  pasteDraft(){
    const savedData = localStorage.getItem('formOperationalActivity');
    if (savedData) {
      let saved = JSON.parse(savedData);
      delete saved.startDate
      delete saved.endDate
      delete saved.vehicles
      delete saved.fleetId
      delete saved.voyageActivityType
      delete saved.newTrip

      this.formOperationalActivity = {
        ...this.formOperationalActivity,
        ...saved,
      }
      this.$swal('Paste.', 'Data Paste.', 'success')
    } else {
      this.$swal('Oops.', 'No data on draft.', 'warning')
    }
  },

  handleChangeProject(selectedValue) {
    if(selectedValue){
      let projectSelected = this.projectOptions.find(obj => obj.value === selectedValue)
      this.formOperationalActivity.polStsMv = projectSelected.sts
      this.formOperationalActivity.podStsMv = projectSelected.sts
    }
  }, 
  handleOriginChange(selectedValue) {
    if (selectedValue === 'Other') {
      this.formOperationalActivity.origin = 'Other';
    } else {
      // Ensure `positionList` is an array before using `find()`
      const origin = this.positionListPOL.find(obj => obj.value === selectedValue)?.text;
      this.formOperationalActivity.origin = origin || 'Other';
    }
  },
  handleDestinationChange(selectedValue) {
    if (selectedValue === 'Other') {
      this.formOperationalActivity.destination = 'Other';
    } else {
      // Ensure `positionList` is an array before using `find()`
      const destination = this.positionListPOD.find(obj => obj.value === selectedValue)?.text;
      this.formOperationalActivity.destination = destination || 'Other';
    }
  },

  toEditHistory(activityId) {
    this.$router.push({
      name: 'dashboard.operational-input',
      query: {
        vehicleId: this.$route.query.vehicleId,
        activityEditId: activityId,
      },
    })
  },
  removeActivityParams() {
    this.$router.push({
      name: 'dashboard.operational-input',
      query: {
        vehicleId: this.$route.query.vehicleId,
      },
    })
  },
  addMinutes(dateString, minutes) {
    return moment(dateString, "DD-MM-YYYY HH:mm")
      .add(minutes, "minute")
      .format("DD-MM-YYYY HH:mm");
  },
  getStartDateForUnfinishedTrip(dateString){
    let newDate = moment(dateString, "DD-MM-YYYY HH:mm")
      // .add(1, 'minute')
      //  Menambah 1 menit
      .format("DD-MM-YYYY HH:mm");

    return newDate;
  },
  async getDetailTrip(tripId, vehicleId){
    let params = {
      tripId,
      vehicleId,
    }
    let res = await this.getVoyageTripDetail(params)
    if(res.status === 'success'){
      let data = res?.data?.activities

      console.log(data?.[0], "data?.[0]")

      return data || null
    }
    return null
  },
  async onCheckedUnfinishedTrip(index){
    this.unfinishedTrip = this.unfinishedTrip.map((val, valIndex) => {
      if(valIndex !== index) {
        val.checked = false
      } 

      return val
    })

    let checkedTrip = this.unfinishedTrip.find(obj => obj.checked)
    this.formOperationalActivity.endDate = null

    if(checkedTrip?.vehicle?.length === 2){
      this.formOperationalActivity.voyageActivityType = 'SINGLE_TOWING'
    } else if(checkedTrip?.vehicle?.length >= 3){
      this.formOperationalActivity.voyageActivityType = 'DOUBLE_TOWING'
      this.formOperationalActivity.vehicles[0].vehicleId = checkedTrip?.vehicle?.[1]?.id
    } else {
      this.formOperationalActivity.voyageActivityType = 'UNTOWING'
    }

    checkedTrip?.vehicle?.filter((el, i) => el.id !== Number(this.$route.query?.vehicleId)).map((el, i) => {
      this.formOperationalActivity.vehicles[i].vehicleId = el.id
    })
    let tempActivity = await this.getDetailTrip(checkedTrip?.id, this.$route.query?.vehicleId)
    let activities = tempActivity?.[0]

    this.checkedActivies = tempActivity
    if(activities){
      this.formOperationalActivity.voyageActivityType = activities?.voyageType
      this.formOperationalActivity.startDate =  this.getStartDateForUnfinishedTrip(activities.endDate)
      this.formOperationalActivity.endDate =  this.getStartDateForUnfinishedTrip(activities.endDate)
      this.activitiesUnfinishedTrip = activities
    } else {
      this.activitiesUnfinishedTrip = null
    }
  },
  async onCheckedCrossTrip(trip,index){
    this.crossTripList = this.crossTripList.map((val, valIndex) => {
      if(valIndex !== index) {
        val.checked = false
      } 

      return val
    })

    let checkedTrip = this.crossTripList.find(obj => obj.checked)
    this.formOperationalActivity.endDate = null

    const filterVehicle = trip?.vehicle?.filter((el)=> el.id != this.formOperationalActivity.fleetId)

    if(filterVehicle?.length){
      this.formOperationalActivity.vehicles[0].vehicleId = filterVehicle[0]?.id
    }


    if(checkedTrip?.vehicle?.length === 2){
      this.formOperationalActivity.voyageActivityType = 'SINGLE_TOWING'
    } else if(checkedTrip?.vehicle?.length >= 3){
      this.formOperationalActivity.voyageActivityType = 'DOUBLE_TOWING'
      if(filterVehicle?.length > 1){
        this.formOperationalActivity.vehicles[1].vehicleId = filterVehicle[1]?.id
      }
    } else {
      this.formOperationalActivity.voyageActivityType = 'UNTOWING'
    }


    let tempActivity = await this.getDetailTrip(checkedTrip?.id, this.formOperationalActivity.fleetId)
    let activities = tempActivity?.[0]

    this.checkedActivies = tempActivity
    if(activities){
      this.formOperationalActivity.voyageActivityType = activities?.voyageType
      this.formOperationalActivity.startDate =  this.getStartDateForUnfinishedTrip(activities.endDate)
      this.formOperationalActivity.endDate =  this.getStartDateForUnfinishedTrip(activities.endDate)
      this.activitiesUnfinishedTrip = activities
    } else {
      this.activitiesUnfinishedTrip = null
    }
  },
  validationTime(oldTime, currentTime, labelCurrent, labelBefore, indexes){
    // Parse the datetime strings using Moment.js
    let old = moment(new Date(oldTime), 'DD-MM-YYYY HH:mm');
    let current = moment(new Date(currentTime), 'DD-MM-YYYY HH:mm');

    this.errorTimeIndex = indexes

    if (current.isSameOrBefore(old)) {
      this.errorTimeText = `${labelCurrent} must greater than ${labelBefore}`
      this.errorValidation =  true
      return
    } 

    this.errorTimeText = ''
    this.currentValidTime = currentTime
    this.errorValidation =  false
  },
  addShelter(){
    this.formOperationalActivity.shelter.push({
      "shelterLocationOther": this.formOperationalActivity?.currentPositionOther, 
      "destinationOther":"", 
      "shelterFor": this.formOperationalActivity.voyageFor, 
      "shelterForOtherValue": this.formOperationalActivity.voyageForOtherValue, 
      "shelterLocation": this.formOperationalActivity.currentPosition,
      "destination": "",
      "arrivalShelter": "",
      "dropAnchorShelter": "",
      "fullAwayShelter": "",
      "remarks": ""
    })
  },
  resetForm(){
    this.removeActivityParams()
    this.nextStep = false
    this.locked = false
    this.isOldActivity = false
    this.loadingCheck = false
    this.activityData = null
    
    // this.unfinishedTrip = []

    this.formOperationalActivity =  {
      ...this.formOperationalActivity,
      activityType: 'trip',
      voyageActivityType: 'UNTOWING',
      subProjectId: '',
      reasonId: '',
      cargoType: '',
      cargoLoading: '',
      cargoUnloading: '',
      remarks: '',
      currentPosition: '',
      arrival: '',
      departure: '',
      portLoading: '',
      portLoadingOther: '',
      portDischarge: '',
      portDischargeOther: '',
      agentPol: '',
      agentPod: '',
      dmsLat: '',
      dmsLon: '',
      lat: '',
      lon: '',
      speed: 1,
      pic: [],
      endOfTrip: true,
      "destinationOther": "",
      "originOther": "",
      "newTrip": false,
      "polCargoUnit": "",
      "polAnchorUp": "",
      "polArrivalTime":"",
      "polBerthing":"",
      "polCommenced":"",
      "polCompleted":"",
      "polDocOnBoard":"", 
      "docOnBoard":"", 
      "polDeparture":"",
      "polCastIn":"",
      "polCastOut":"",
      "polNor":"",
      "polNoa":"",
      "polLhv":"",
      "podCargoUnit":"",
      "podAnchorUp":"",
      "podLhv":"",
      "podDeparture":"",
      "podArrivalTime":"",
      "podBerthing":"",
      "podCommenced":"",
      "podCompleted":"",
      "podNor":"",
      "podNoa":"",
      "podCastIn":"",
      "podCastOut":"",
      "voyageFor": "loading",
      "voyageForOtherValue": "",  
      "origin": "",
      "destination": "",
      "speedBySystem": 1,
      "polDraughtSurvey": 0,
      "podDraughtSurvey": 0,
      "polBlDate":"",
      "podBlDate":"",

      "shelter": [{
        "shelterLocationOther": "", 
        "destinationOther": "", 
        "shelterFor": "", // loading, discharge, others
        "shelterLocation": "",
        "destination": "",
        "arrivalShelter": "",
        "dropAnchorShelter": "",
        "fullAwayShelter": "",
        "remarks": ""
      }]
    }

    this.unfinishedTrip?.map(val => {
      val.checked = false

      return val
    })
    this.crossTripList?.map(val => {
      val.checked = false

      return val
    })

    this.isActivityId = null
    this.isEdit = false

    if(this.unfinishedTrip.length <= 0) this.formOperationalActivity.newTrip = true
    this.initActivityForm()
  },
  resetFormState(){
    this.nextStep = false
    this.locked = false
    this.isOldActivity = false
    this.loadingCheck = false
    this.activityData = null

    this.formOperationalActivity =  {
      ...this.formOperationalActivity,
      activityType: 'trip',
      subProjectId: '',
      reasonId: '',
      cargoType: '',
      cargoLoading: '',
      cargoUnloading: '',
      remarks: '',
      currentPosition: '',
      arrival: '',
      departure: '',
      portLoading: '',
      portLoadingOther: '',
      portDischarge: '',
      portDischargeOther: '',
      agentPol: '',
      agentPod: '',
      dmsLat: '',
      dmsLon: '',
      lat: '',
      lon: '',
      speed: 1,
      pic: [],
      "destinationOther": "",
      "originOther": "",
      "polCargoUnit": "",
      "polAnchorUp": "",
      "polArrivalTime":"",
      "polBerthing":"",
      "polCommenced":"",
      "polCompleted":"",
      "polDocOnBoard":"", 
      "docOnBoard":"", 
      "polDeparture":"",
      "polCastIn":"",
      "polCastOut":"",
      "polNor":"",
      "polNoa":"",
      "polLhv":"",
      "podCargoUnit":"",
      "podAnchorUp":"",
      "podLhv":"",
      "podDeparture":"",
      "podArrivalTime":"",
      "podBerthing":"",
      "podCommenced":"",
      "podCompleted":"",
      "podNor":"",
      "podNoa":"",
      "podCastIn":"",
      "podCastOut":"",
      "origin": "",
      "destination": "",
      "speedBySystem": 1,
      "polDraughtSurvey": 0,
      "podDraughtSurvey": 0,
      "polBlDate":"",
      "podBlDate":"",
      "polRemark":"",
      "podRemark":"",

      "shelter": [{
        "shelterLocationOther": "", 
        "destinationOther": "", 
        "shelterFor": "", // loading, discharge, others
        "shelterLocation": "",
        "destination": "",
        "arrivalShelter": "",
        "dropAnchorShelter": "",
        "fullAwayShelter": "",
        "remarks": ""
      }]
    }

    this.unfinishedTrip?.map(val => {
      val.checked = false

      return val
    })
    this.crossTripList?.map(val => {
      val.checked = false

      return val
    })

    this.dmsLat = {
      degrees: '',
      minutes: '',
      seconds: '',
      directions: 'S'
    }
    this.dmsLon = {
      degrees: '',
      minutes: '',
      seconds: '',
      directions: 'E'
    }
  },
  onChangeFleet(e){
    this.fetchCrossTrip(e)
  },
  async fetchUnfinishTrip () {
    this.unfinishedTrip = []
    console.log(this.$route.query.vehicleId, "this.$route.query.vehicleId")
    let params = {
      vehicleId: this.$route.query.vehicleId
    }

    const res = await this.getVoyageUnfinishedTrip(params)

    if (res.status == 'success') {
      let vehicle = []
      res.data.map(val => {
        vehicle = val.vehicle
        this.unfinishedTrip.push({
          ...val,
          checked:this.$route.query?.activityEditId ? true : false
        })
      })

      vehicle?.filter((el, i) => el.id !== Number(this.$route.query?.vehicleId))
      // .map((el, i) => {
      //   this.formOperationalActivity.vehicles[i].vehicleId = el.id
      // })
      if (vehicle.length == 2) this.formOperationalActivity.voyageActivityType = 'SINGLE_TOWING';
      if (vehicle.length == 3) this.formOperationalActivity.voyageActivityType = 'DOUBLE_TOWING';
    }

    if(this.unfinishedTrip.length <= 0) this.formOperationalActivity.newTrip = true
  },

  async fetchCrossTrip (vehicleId) {
    this.crossTripList = []
    let params = {
      vehicleId
    }
    const res = await this.getVoyageUnfinishedTrip(params)

    if (res.status == 'success' && res?.data?.length > 0) {
      res?.data?.map(val => {
        this.crossTripList.push({
          ...val,
          checked: false
        })
      })
    }
  }, 
   async fetchFleets() {
    let params = {
      page: 1,
      perPage: 9999,
      showAll: true,
      active: true,
    }

    let res = await this.getFleets(params)

    console.log(res, " fleets ")
    if (res.data && res.data.length > 0) {
      this.optionsFleets = res.data.map((val) => {
        return {
          ...val,
          text: val?.name,
          value: val.id,
        }
      })
    }
  },
  async getUnit () {
    this.optionsUnit = []
    const res = await this.fetchUnit()

    if (res.data.status == true) {
      if(res.data.data.length > 0){
        let data = res.data.data.filter(val => val.child.length <= 0)

        let tempArr = []
        data?.map(val => {
          tempArr.push({
            text:`${val?.name}`,
            value:`${val?.name}`
          })
        })
        this.optionsUnit = tempArr
      }
    }
  },

  async getCargoType () {
    this.optionsCargoType = []

    const res = await this.fetchCargoType()

    if (res.data.status == true) {
      let tempArr = []
      if(res.data.data.length > 0){
        res.data.data.map(val => {
          tempArr.push({
            text:`${val?.name}`,
            value:`${val?.name}`,
            ...val
          })
        })
        this.optionsCargoType = tempArr
      }
    
    } 
  },
  async fetchFleetById () {
    this.loadingForm = true
    const res = await this.getFleetById(this.vehicleId)

    if (res.status == 'success') {
      this.fleet = res.data
      console.log('fleet', this.fleet)
    } else {
      this.fleet = {}
      this.$swal(
        `Oops!`,
        res.data,
        'error'
      )
    }
    this.loadingForm = false
  },
  async listFleet () {
    if (this.fleet.vehicleType?.name == 'Tugboat') {
      let params = {
        vehicleTypeId: [1, 2],
        page: 1,
        active: true,
        showAll: true
      }
      const res = await this.getFleets(params)
      if (res.status == 'success') {
        this.fleetList = res.data
      } else {
        this.fleetList = {}
        this.$swal(
          `Oops!`,
          res.data,
          'error'
        )
      }
    } else if (this.fleet.vehicleType?.name == 'Pusher Tug') {
      let params = {
        vehicleTypeId: [21, 22],
        page: 1,
        active: true,
        showAll: true
      }
      const res = await this.getFleets(params)
      if (res.status == 'success') {
        this.fleetList = res.data
      } else {
        this.fleetList = {}
        this.$swal(
          `Oops!`,
          res.data,
          'error'
        )
      }
    } else {
      let params = {
        page: 1,
        active: true,
        showAll: true
      }
      const res = await this.getFleets(params)
      if (res.status == 'success') {
        this.fleetList = res.data
      } else {
        this.fleetList = {}
        this.$swal(
          `Oops!`,
          res.data,
          'error'
        )
      }
    }
  },
  async getProjectList () {
    let params = {
      active: true,
      search: '',
      page: 1,
      perPage: 99999
    }
    const res = await this.getProjects(params)

    if((res?.data?.status == 'success' || res?.data?.status == true) && res.data.data.length > 0) {
      res.data.data?.map(val => {
        val.subProject?.map(obj => {
          this.projectOptions.push({
            value: obj.id,
            text: `${val.projectName} - ${obj?.name}`,
            bdCustomer: val.bdCustomer,
            isSts: val.isSts,
            sts: val.sts,
            vehicleType: val.vehicleType,
            projectId: val.id,
            projectName:val.projectName,
            projectSub:obj?.name,
            location:val.location,
            status:val.active,
          })
        })
      })
    }
    // if (res.status == 'success') {
    //   if (res.data.data && res.data.data.length > 0) {
    //     res.data.data.forEach(val => {
    //       this.projectOptions.push({
    //         project: val.projectName,
    //         sub: val.subProject
    //       })
    //     })
    //   }
    // } else {
    //   this.$swal(
    //     `Oops!`,
    //     res.data.data,
    //     'error'
    //   )
    // }
  },
  async getReasonList () {
    let params = {
      search: '',
      vehicleTypeId: this.fleet.vehicleType.id,
      page: 1,
      perPage: 99999
    }
    const res = await this.getReasons(params)
    if (res.status == 'success') {
      if (res.data.data && res.data.data.length > 0) {
        res.data.data.forEach(val => {
          if(val.active === true){
            this.reasonList.push({ value: val.id, text: val?.name })
          }
        })
      }
    } else {
      this.$swal(
        `Oops!`,
        res.data.data,
        'error'
      )
    }
  },
  async getPortListText () {
    let params = {
      active: true,
      search: '',
      page: 1,
      perPage: 99999
    }
    const res = await this.getPorts(params)
    if (res.status == 'success') {
      if (res.data.data && res.data.data.length > 0) {
        res.data.data.forEach((val, index) => {
          if(val.portType === 'LOADING_PORT'){
            this.positionListTextPOL.push({ value: val.portName, text: `${val.portName}`, ...val })
            this.positionListPOL.push({ value: val.id, text: `${val.portName}`, ...val })
          } else if(val.portType === 'DISCHARGING_PORT'){
            this.positionListTextPOD.push({ value: val.portName, text: `${val.portName}`, ...val })
            this.positionListPOD.push({ value: val.id, text: `${val.portName}`, ...val })
          }
        })
      }
    } else {
      this.$swal(
        `Oops!`,
        res.data.data,
        'error'
      )
    }
  },
  async getUserList () {
    let params = {
      active: true,
      page: 1,
      perPage: 100000
    }
    const res = await this.getUsers(params)
    if (res.data.status == 'success' || res.data.status == true) {
      if (res.data.data && res.data.data.length > 0) {
        res.data.data.forEach(val => {
          this.picList.push({ value: val.id, text: val.userDetail?.name })
        })
        // const findIdx = this.picList.findIndex(val => val.value === this.fleet.id)
        // if (findIdx !== -1) this.picSelected = this.fleet.id
      }
    } else {
      this.$swal(
        `Oops!`,
        res.message,
        'error'
      )
    }
  },
  async getLastActivity () {
    this.activityList = []
    const vehicleId = this.$route.query.vehicleId
    let params = {
      page: 1
    }
    const payload = {
      vehicleId: vehicleId,
      params
    }
    const res = await this.getVoyageLastActivity(payload)
    if (res.status == 'success') {
      if (res.data && res.data.length > 0) {
        this.activityList = res.data

        this.formOperationalActivity.startDate = this.activityList?.[0]?.endDate || null
        this.formOperationalActivity.endDate = this.activityList?.[0]?.endDate || null
      }
    } else {
      this.$swal(
        `Oops!`,
        res.data,
        'error'
      )
    }
  },

  async getActivityDetail (activityId, isEdit = false) {
    try {
      this.toEditHistory(activityId)
      const vehicleId = this.$route.query.vehicleId
      const res = await this.getActivityById({ vehicleId, id: activityId })
      if (res.status === 'success') {
        if (isEdit) {
          this.isActivityId = res.data.id
          this.isEdit = true
        }
        this.activityData = res.data
        this.initActivityForm(1, res.data)
        this.nextStep = true
        this.loadingCheck = false

        if(!res.data?.tripId && this.$route.query.activityEditId){
          // this.formOperationalActivity.activityType = 'non trip'
        } else {
          this.formOperationalActivity.tripId = res.data?.tripId
          // this.formOperationalActivity.activityType = 'trip'
        }
      } else {
        this.$swal(
          `Oops!`,
          res.data,
          'error'
        )
      }
    } catch (err) {
       console.log(err)
       this.loadingCheck = false
      this.loadingOperational = false
    } finally {
      this.loadingCheck = false
      this.loadingOperational = false
    }
  },
  async checkVoyage () {
    let self = this
    const vehicleId = this.$route.query.vehicleId
    this.$v.formOperationalActivity.$touch()

    let unfinished = this.unfinishedTrip?.find(obj => obj.checked)

    if(!this.formOperationalActivity.newTrip && this.unfinishedTrip.length > 0 && !this.formOperationalActivity.isCrossTrip && this.formOperationalActivity.activityType === 'trip'){
      let dateUnfinished = moment(unfinished?.startDate, 'DD-MM-YYYY HH:mm');
      let startDate = moment(this.formOperationalActivity.startDate, 'DD-MM-YYYY HH:mm');

      console.log(dateUnfinished.format('YYYY-MM-DD HH:mm'), "unfinished");
      console.log(startDate.format('YYYY-MM-DD HH:mm'), "startDate");

      if (startDate.isBefore(dateUnfinished)) {
        this.$swal(
          'Can’t process.',
          'Start Date Activity can’t be earlier than Start Date unfinished trip.',
          'warning'
        );
        return;
      }
      // const index = this.unfinishedTrip?.findIndex(obj => obj.checked);
      // let checked = null;
      // let nextChecked = null;
      // if (index !== -1 && index !== undefined) {
      //   checked = this.unfinishedTrip[index];
      //   nextChecked = this.unfinishedTrip[index + 1] || null; 
      // }

      // // Example inputs
      // const start_trip =new Date(this.formOperationalActivity.startDate) // User input
      // const end_trip = new Date(this.formOperationalActivity.endDate)
      // // Parse object dates
      // const checkedStart = new Date(checked.startDate);
      // const nextStart = nextChecked ? new Date(nextChecked.startDate) : null;
      // // Validate only if nextChecked exists
      // let isValid = true;
      // if (nextStart) {
      //   isValid =
      //     start_trip >= checkedStart &&
      //     end_trip <= nextStart &&
      //     start_trip <= end_trip; // optional: ensure start before end
      // } else {
      //   // If no nextChecked, validate only against checked.startDate
      //   isValid =
      //     start_trip >= checkedStart &&
      //     start_trip <= end_trip; // still ensure logical order
      // }

      // if (!isValid) {
      //   this.$swal(
      //     'Oops.',
      //     'Tanggal Aktifitas tidak boleh melebihi Trip Selanjut nya yang belum finish.',
      //     'warning'
      //   )
      //   return
      // } 
    }

    let isCrossTrip = this.crossTripList?.find(obj => obj.checked)
    if(this.formOperationalActivity.isCrossTrip && !isCrossTrip && !this.formOperationalActivity.newTrip && this.formOperationalActivity.activityType === 'trip'){
      this.$swal(
        'Required.',
        'Choose atleast 1 Cross Trip or uncheck the cross trip to process.',
        'warning'
      ) 
      return
    }

    if (new Date(this.formOperationalActivity.endDate) <= new Date(this.formOperationalActivity.startDate)) {
      this.$swal(
        'Error',
        'End Date harus lebih besar dari Start Date',
        'error'
      )
      return
    }

    if (!this.$v.formOperationalActivity.$invalid) {
      this.loadingCheck = true
      let param = {
        'startDate': this.formOperationalActivity.startDate,
        'endDate': this.formOperationalActivity.endDate,
        'vehicles': [
          {
            'vehicleId': Number(this.formOperationalActivity.vehicles[0].vehicleId),
            'vehicleNumber': 1,
            'breakdown': this.formOperationalActivity.vehicles[0].breakdown
          },
          {
            'vehicleId': Number(this.formOperationalActivity.vehicles[1].vehicleId),
            'vehicleNumber': 2,
            'breakdown': this.formOperationalActivity.vehicles[1].breakdown
          }
        ]
      }

      if (this.formOperationalActivity.voyageActivityType === 'UNTOWING') {
        delete param.vehicles
      } else if (this.formOperationalActivity.voyageActivityType === 'SINGLE_TOWING') {
        param.vehicles.splice(1, 1)
      }

      const vehicleId = this.$route.query.vehicleId
      let res = await self.checkVehicleVoyage({ vehicleId, data: param })
      if(res.status === 'success') {
        this.$swal('Available!', res.data.message, 'success')

  
        if(unfinished && !this.formOperationalActivity.newTrip && this.formOperationalActivity.activityType === 'trip'){
          this.initActivityForm(1, unfinished, true)
        }  
        
        if(isCrossTrip && !this.formOperationalActivity.newTrip && this.formOperationalActivity.activityType === 'trip'){
          this.initActivityForm(1, isCrossTrip, true)
          console.log('IS this work')
        }

        // if (this.activityList[0]) {
        //   await this.getActivityDetail(this.activityList[0].id)
        // }
       
      } else {
        if (res.data.message != null) {
          this.$swal('Error', res.data.message, 'error')
          this.loadingCheck = false
        } else {
          this.$swal(
            'Error',
            'Something wrong with the server. Please try again later.',
            'error'
          )
          this.loadingCheck = false
        }
        return
      }
    }

    if(this.formOperationalActivity.newTrip && this.formOperationalActivity.activityType === 'trip' && !this.formOperationalActivity.isCrossTrip) this.resetFormState()

    this.$swal('Available!', 'available to next step', 'success')
    this.nextStep = true
    this.locked = true
  },
  process () {
    let timerInterval
    this.$swal.fire({
      title: 'Check Available!',
      timer: 500,
      timerProgressBar: true,
      didOpen: () => {
        this.$swal.showLoading()
        timerInterval = setInterval(() => {
          const content = this.$swal.getContent()
          if (content) {
            const b = content.querySelector('b')
            if (b) {
              b.textContent = this.$swal.getTimerLeft()
            }
          }
        }, 100)
      },
      willClose: () => {
        clearInterval(timerInterval)
      }
    }).then((result) => {
      this.nextStep = true
    })
  },
  edit () {
    this.nextStep = false
    this.loadingCheck = false
    this.endDate = ''
  },
  handleSelectFleet (data, e, idx) {
    let findIdx = data.findIndex(val => val.id === e)
    this.formOperationalActivity.vehicles[idx].breakdown = false
    if (findIdx !== -1) {
      if (data[findIdx].vehicleType.id === this.fleet.vehicleType.id) {
        this.formOperationalActivity.vehicles[idx].breakdown = true
      }
    }
  },
  initActivityForm (type, data, continueTrip) {
   try {
    if (type) {
      var date = new Date()

      if (this.isEdit || this.$route?.query?.activityEditId) {
        this.formOperationalActivity.startDate = data?.startDate
        this.formOperationalActivity.endDate = data?.endDate
        this.formOperationalActivity.newTrip = data?.newTrip ? true : false
        this.formOperationalActivity.isCrossTrip = data?.isCrossTrip ? true : false

        this.formOperationalActivity.voyageActivityType = data?.voyageType
        this.formOperationalActivity.vehicles = [
          {
            vehicleId: data && (data.voyageType === 'SINGLE_TOWING' || data.voyageType === 'DOUBLE_TOWING') ? data?.vehicle?.[1]?.id : '',
            vehicleNumber: data && (data.voyageType === 'SINGLE_TOWING' || data.voyageType === 'DOUBLE_TOWING') ? data?.vehicle?.[1]?.vehicleNumber : 1,
            breakdown: data && (data.voyageType === 'SINGLE_TOWING' || data.voyageType === 'DOUBLE_TOWING') ? data?.vehicle?.[1]?.breakdown : false
          },
          {
            vehicleId: data && data.voyageType === 'DOUBLE_TOWING' ? data?.vehicle?.[2]?.id : '',
            vehicleNumber: data && data.voyageType === 'DOUBLE_TOWING' ? data?.vehicle?.[2]?.vehicleNumber : 2,
            breakdown: data && data.voyageType === 'DOUBLE_TOWING' ? data?.vehicle?.[2]?.breakdown : false
          }
        ]

        this.formOperationalActivity.reasonId = data ? `${data.reason.id}|${data.reason?.name}` : ''
        this.formOperationalActivity.cargoType = data?.cargoType,
        this.formOperationalActivity.cargoLoading = data && data.reason?.name === 'Loading' ? data.cargoLoading : ''
        this.formOperationalActivity.activityType = data.activityType || null
      }
      this.fleetEdit = data ? data.vehicle[0] : null
    } else {
      if(['BARGE', 'PUSHER BARGE'].includes(this.fleet.vehicleType?.name)){
        this.formOperationalActivity.voyageActivityType = 'SINGLE_TOWING'
      }
    }
    this.formOperationalActivity.endOfTrip = data?.isEndTrip || false

    this.formOperationalActivity.subProjectId = data?.subProject?.id || this.projectOptions?.find(obj => obj.projectName === 'No Project').value || null

    this.formOperationalActivity.cargoUnloading = data && data.reason?.name === 'Unloading' ? data.cargoUnloading : ''
    this.formOperationalActivity.currentPosition = data?.currentPosition
    this.formOperationalActivity.currentPositionOther = data?.currentPositionOther
    if(data?.portLoading){
      this.formOperationalActivity.portLoading = data?.portLoading ? Number(data?.portLoading?.id) : null
    } else {
      this.formOperationalActivity.portLoading = 'Other'
      this.formOperationalActivity.portLoadingOther = data?.portLoadingOther
    }

    if(data?.portDischarge){
      this.formOperationalActivity.portDischarge = data?.portDischarge ? Number(data?.portDischarge?.id) : null
    } else {
      this.formOperationalActivity.portDischarge = 'Other'
      this.formOperationalActivity.portDischargeOther = data?.portDischargeOther
    }
    this.formOperationalActivity.agentPol = data ? data.agentPol : ''
    this.formOperationalActivity.agentPod = data ? data.agentPod : ''
    this.formOperationalActivity.lat = data ? (data.lat ? data.lat : '') : ''
    this.formOperationalActivity.lon = data ? (data.lon ? data.lon : '') : ''
    this.formOperationalActivity.speed = data ? data.speed : 1
  
    this.formOperationalActivity.polDraughtSurvey = data ? Number(data.polDraughtSurvey) : 0
    this.formOperationalActivity.podDraughtSurvey = data ? Number(data.podDraughtSurvey) : 0
    this.formOperationalActivity.speedBySystem = data ? data.speedBySystem : 1
    this.formOperationalActivity.polCargoUnit = data ? data.polCargoUnit : ''
    this.formOperationalActivity.podCargoUnit = data ? data.podCargoUnit : ''
    this.formOperationalActivity.voyageFor = data ? data.voyageFor : ''
    this.formOperationalActivity.voyageForOtherValue = data ? data.voyageForOtherValue : ''
    this.formOperationalActivity.polDocOnBoard = data?.polDocOnBoard || ''
    this.formOperationalActivity.polAnchorUp = data?.polAnchorUp || ''
    this.formOperationalActivity.polArrivalTime = data?.polArrivalTime || ''
    this.formOperationalActivity.polBerthing = data?.polBerthing || ''
    this.formOperationalActivity.polCommenced = data?.polCommenced || ''
    this.formOperationalActivity.polCompleted = data?.polCompleted || ''
    this.formOperationalActivity.polDeparture = data?.polDeparture || ''
    this.formOperationalActivity.polLhv = data?.polLhv || ''
    this.formOperationalActivity.polRemark = data?.polRemark || ''
    this.formOperationalActivity.podRemark = data?.podRemark || ''
    this.formOperationalActivity.podAnchorUp = data?.podAnchorUp || ''
    this.formOperationalActivity.podLhv = data?.podLhv || ''
    this.formOperationalActivity.podCastOut = data?.podCastOut || ''
    this.formOperationalActivity.podDeparture = data?.podDeparture || ''
    this.formOperationalActivity.podArrivalTime = data?.podArrivalTime || ''
    this.formOperationalActivity.podBerthing = data?.podBerthing || ''
    this.formOperationalActivity.podCommenced = data?.podCommenced || ''
    this.formOperationalActivity.podCompleted = data?.podCompleted || ''
    this.formOperationalActivity.podCompleted = data?.podCompleted || ''

    this.formOperationalActivity.arrival = data?.arrival || ''
    this.formOperationalActivity.departure = data?.departure || ''

    this.formOperationalActivity.endOfTrip = data?.endOfTrip ? true : false

    // New 
    this.formOperationalActivity.polStsMv = data?.polStsMv ? true : false
    this.formOperationalActivity.podStsMv = data?.podStsMv ? true : false
    this.formOperationalActivity.polMvName = data?.polMvName
    this.formOperationalActivity.podMvName = data?.podMvName
    this.formOperationalActivity.polGrabType = data?.polGrabType
    this.formOperationalActivity.podGrabType = data?.podGrabType
    this.formOperationalActivity.polFcName = data?.polFcName
    this.formOperationalActivity.podFcName = data?.podFcName
    this.formOperationalActivity.polBlDate = data?.polBlDate

    this.formOperationalActivity.polBlDate = data?.polBlDate
    
    this.formOperationalActivity.podNor = data?.podNor || ''
    this.formOperationalActivity.podNoa = data?.podNoa || ''
    this.formOperationalActivity.podCastIn = data?.podCastIn || ''
    this.formOperationalActivity.podCastOut = data?.podCastOut || ''
    this.formOperationalActivity.polNor = data?.polNor || ''
    this.formOperationalActivity.polNoa = data?.polNoa || ''
    this.formOperationalActivity.polCastIn = data?.polCastIn || ''
    this.formOperationalActivity.polCastOut = data?.polCastOut || ''

    // this.formOperationalActivity.docOnBoard = data?.docOnBoard || ''
    this.formOperationalActivity.pic = []
    if (this.isEdit) {
      this.typeOfCargo = data ? (data.reason?.name === 'Loading' && this.cargoOptions.findIndex(val => val.value === data.cargoType) !== -1 ? data.cargoType : 'Other') : ''
      this.typeOfCargoOther = data && data.reason?.name === 'Loading' && this.typeOfCargo === 'Other' ? data.cargoType : ''
    }
    this.picSelected = data?.pic ? data.pic.map(pic => pic?.id) : [JSON.parse(localStorage.getItem('profile'))?.id]

    this.dmsLat.degrees = data ? data?.dmsLatitude?.split(' ')[0]?.substr(0, data?.dmsLatitude?.split(' ')[0].length - 1) : ''
    this.dmsLat.minutes = data ? data?.dmsLatitude?.split(' ')[1]?.substr(0, data?.dmsLatitude?.split(' ')[1].length - 1) : ''
    this.dmsLat.seconds = data ? data?.dmsLatitude?.split(' ')[2]?.substr(0, data?.dmsLatitude?.split(' ')[2].length - 1) : ''
    this.dmsLat.directions = data ? data?.dmsLatitude?.split(' ')[3] : ''

    this.dmsLon.degrees = data ? data?.dmsLongitude?.split(' ')[0]?.substr(0, data?.dmsLongitude?.split(' ')[0].length - 1) : ''
    this.dmsLon.minutes = data ? data?.dmsLongitude?.split(' ')[1]?.substr(0, data?.dmsLongitude?.split(' ')[1].length - 1) : ''
    this.dmsLon.seconds = data ? data?.dmsLongitude?.split(' ')[2]?.substr(0, data?.dmsLongitude?.split(' ')[2].length - 1) : ''
    this.dmsLon.directions = data ? data?.dmsLongitude?.split(' ')[3] : ''

    if(continueTrip) {
      this.formOperationalActivity.origin = this.positionListPOL.find(obj => obj.value === this.formOperationalActivity.portLoading)?.text
      this.formOperationalActivity.originOther = this.formOperationalActivity.portLoadingOther
      this.formOperationalActivity.destination = this.positionListPOD.find(obj => obj.value === this.formOperationalActivity.portDischarge)?.text
      this.formOperationalActivity.destinationOther = this.formOperationalActivity.portDischargeOther

      this.formOperationalActivity.remarks = ''
      // this.formOperationalActivity.polRemark = ''
      // this.formOperationalActivity.podRemark = ''
      // this.useShelter = false
      // this.formOperationalActivity.shelter = []

    } else {
      this.formOperationalActivity.remarks = data?.remark || ''
      this.formOperationalActivity.origin = data?.origin || ''
      this.formOperationalActivity.originOther = data?.originOther || ''
      this.formOperationalActivity.destination = data?.destination || ''
      this.formOperationalActivity.destinationOther = data?.destinationOther || ''
    } 
    this.useShelter = data?.shelter?.length > 0 ? true : false
    this.formOperationalActivity.shelter = data?.shelter

    this.formOperationalActivity.endOfTrip = data?.isEndTrip || false
    console.log(data?.isEndTrip , "data?.isEndTrip ")
   } catch (err) {
    console.log(err)
   }
  },
  generateGPSLat () {
    if (this.dmsLat.degrees && this.dmsLat.minutes && this.dmsLat.seconds) {
      this.formOperationalActivity.lat = singleConvertDMSToDD(this.combineDNSLat)
    }
  },
  generateGPSLng () {
    if (this.dmsLon.degrees && this.dmsLon.minutes && this.dmsLon.seconds) {
      this.formOperationalActivity.lon = singleConvertDMSToDD(this.combineDNSLng)
    }
  },
  async saveOldActivity(){
    try {
      let payload = {
        'startDate': this.formOperationalActivity.startDate || null,
        'endDate': this.formOperationalActivity.endDate || null,
        'vehicles': this.formOperationalActivity.voyageActivityType === 'SINGLE_TOWING' ?  [
          {
            'vehicleId': this.formOperationalActivity.vehicles[0].vehicleId,
            'vehicleNumber': 1,
            'breakdown': this.formOperationalActivity.vehicles[0].breakdown
          }
        ] : this.formOperationalActivity.voyageActivityType === 'DOUBLE_TOWING' ? [
          {
            'vehicleId': this.formOperationalActivity.vehicles[0].vehicleId,
            'vehicleNumber': 1,
            'breakdown': this.formOperationalActivity.vehicles[0].breakdown
          },
          {
            'vehicleId': this.formOperationalActivity.vehicles[1].vehicleId,
            'vehicleNumber': 2,
            'breakdown': this.formOperationalActivity.vehicles[1].breakdown
          }
        ] : [],
        'voyageActivityType': this.formOperationalActivity.voyageActivityType,
        'subProjectId': this.formOperationalActivity?.subProjectId,
        'reasonId': Number(this.formOperationalActivity.reasonId.split('|')[0]),
        'cargoType': this.formOperationalActivity.reasonId.split('|')[1] === 'Loading' ? this.formOperationalActivity.cargoType : null,
        'cargoLoading': this.formOperationalActivity.reasonId.split('|')[1] === 'Loading' ? Number(this.formOperationalActivity.cargoLoading) : null,
        'cargoUnloading': this.formOperationalActivity.reasonId.split('|')[1] === 'Unloading' ? Number(this.formOperationalActivity.cargoUnloading) : null,
        'remarks': this.formOperationalActivity.remarks,
        'currentPosition': this.formOperationalActivity.currentPosition,
        'currentPositionOther': this.formOperationalActivity.currentPositionOther,
        'arrival': this.formOperationalActivity.arrival,
        'departure': this.formOperationalActivity.departure,
        'portLoading': this.formOperationalActivity.portLoading,
        'portLoadingOther': this.formOperationalActivity.portLoadingOther,
        'portDischarge': this.formOperationalActivity.portDischarge,
        'portDischargeOther': this.formOperationalActivity.portDischargeOther,
        'agentPol': this.formOperationalActivity.agentPol,
        'agentPod': this.formOperationalActivity.agentPod,
        "docOnBoard": this.formOperationalActivity?.polDocOnBoard,
        "endOfTrip": this.formOperationalActivity.endOfTrip,
        'lat': Number(this.formOperationalActivity.lat),
        'lon': Number(this.formOperationalActivity.lon),
        'speed': Number(this.formOperationalActivity?.speed || 1),
        'pic': this.picSelected,
        'dmsLatitude': this.combineDNSLat,
        'dmsLongitude': this.combineDNSLng,
      }

      if(payload.portLoading === 'Other') {
        payload.portLoading = null
      } else {
        payload.portLoadingOther = ''
      }
      if(payload.portDischarge === 'Other') {
        payload.portDischarge = null
      } else {
        payload.portDischargeOther = ''
      }

      if (this.formOperationalActivity.voyageActivityType === 'UNTOWING') {
        delete payload.vehicles
      } else if (this.formOperationalActivity.voyageActivityType === 'SINGLE_TOWING') {
        payload.vehicles.splice(1, 1)
      }

      const id = this.$route.query.vehicleId
      this.$swal.fire({
        title: 'Processing...',
        allowEscapeKey: false,
        allowOutsideClick: false,
        onOpen: () => {
          swal.showLoading()
        }
      })
      
      let res = await this.updateActivity({ id: this.isActivityId, vehicleId: this.fleetEdit.id, data: payload })

      if(res?.data?.status === false){
        this.$swal('Something went wrong!', res.data.message, 'error')
        return
      }

      this.$swal('Activity Saved!', res.data.message, 'success')
      this.$router.push(`/ops/operational?vehicleId=${id}`)
    } catch (err) {
      console.log(err)
      this.$swal(
        'Error',
        'Something wrong with the server. Please try again later.',
        'error'
      )
    }
  },
  async saveNonTripActivity(){
    try {
      let payload = {
        // 'startDate': this.formOperationalActivity.startDate || null,
        // 'endDate': this.formOperationalActivity.endDate || null,
        // 'vehicles': this.formOperationalActivity.voyageActivityType === 'SINGLE_TOWING' ?  [
        //   {
        //     'vehicleId': this.formOperationalActivity.vehicles[0].vehicleId,
        //     'vehicleNumber': 1,
        //     'breakdown': this.formOperationalActivity.vehicles[0].breakdown
        //   }
        // ] : this.formOperationalActivity.voyageActivityType === 'DOUBLE_TOWING' ? [
        //   {
        //     'vehicleId': this.formOperationalActivity.vehicles[0].vehicleId,
        //     'vehicleNumber': 1,
        //     'breakdown': this.formOperationalActivity.vehicles[0].breakdown
        //   },
        //   {
        //     'vehicleId': this.formOperationalActivity.vehicles[1].vehicleId,
        //     'vehicleNumber': 2,
        //     'breakdown': this.formOperationalActivity.vehicles[1].breakdown
        //   }
        // ] : [],
        // 'voyageActivityType': this.formOperationalActivity.voyageActivityType,
        // 'subProjectId': this.formOperationalActivity?.subProjectId,
        // 'reasonId': Number(this.formOperationalActivity.reasonId.split('|')[0]),
        // 'cargoType': this.formOperationalActivity.reasonId.split('|')[1] === 'Loading' ? this.formOperationalActivity.cargoType : null,
        // 'cargoLoading': this.formOperationalActivity.reasonId.split('|')[1] === 'Loading' ? Number(this.formOperationalActivity.cargoLoading) : null,
        // 'cargoUnloading': this.formOperationalActivity.reasonId.split('|')[1] === 'Unloading' ? Number(this.formOperationalActivity.cargoUnloading) : null,
        // 'remarks': this.formOperationalActivity.remarks,
        // 'currentPosition': this.formOperationalActivity.currentPosition,
        // 'currentPositionOther': this.formOperationalActivity.currentPositionOther,
        // 'arrival': this.formOperationalActivity.arrival,
        // 'departure': this.formOperationalActivity.departure,
        // 'portLoading': this.formOperationalActivity.portLoading,
        // 'portLoadingOther': this.formOperationalActivity.portLoadingOther,
        // 'portDischarge': this.formOperationalActivity.portDischarge,
        // 'portDischargeOther': this.formOperationalActivity.portDischargeOther,
        // 'agentPol': this.formOperationalActivity.agentPol,
        // 'agentPod': this.formOperationalActivity.agentPod,
        // "docOnBoard": this.formOperationalActivity?.polDocOnBoard,
        // "endOfTrip": this.formOperationalActivity.endOfTrip,
        // 'lat': Number(this.formOperationalActivity.lat),
        // 'lon': Number(this.formOperationalActivity.lon),
        // 'speed': Number(this.formOperationalActivity?.speed || 1),
        // 'pic': this.picSelected,
        // 'dmsLatitude': this.combineDNSLat,
        // 'dmsLongitude': this.combineDNSLng,
        'subProjectId': this.formOperationalActivity?.subProjectId,
        'startDate': this.formOperationalActivity.startDate || null,
        'endDate': this.formOperationalActivity.endDate || null,
        'vehicles': this.formOperationalActivity.voyageActivityType === 'SINGLE_TOWING' ?  [
          {
            'vehicleId': this.formOperationalActivity.vehicles[0].vehicleId,
            'vehicleNumber': 1,
            'breakdown': this.formOperationalActivity.vehicles[0].breakdown
          }
        ] : this.formOperationalActivity.voyageActivityType === 'DOUBLE_TOWING' ? [
          {
            'vehicleId': this.formOperationalActivity.vehicles[0].vehicleId,
            'vehicleNumber': 1,
            'breakdown': this.formOperationalActivity.vehicles[0].breakdown
          },
          {
            'vehicleId': this.formOperationalActivity.vehicles[1].vehicleId,
            'vehicleNumber': 2,
            'breakdown': this.formOperationalActivity.vehicles[1].breakdown
          }
        ] : [],
        'voyageActivityType': this.formOperationalActivity.voyageActivityType,
        'remarks': this.formOperationalActivity.remarks,
        'currentPosition': this.formOperationalActivity.currentPosition,
        'currentPositionOther': this.formOperationalActivity.currentPositionOther,
        "speed": 1,
        'pic': this.picSelected,
        "activityType": this.formOperationalActivity.activityType,
        'reasonId': Number(this.formOperationalActivity.reasonId.split('|')[0]),
        'cargoType': this.formOperationalActivity.reasonId.split('|')[1] === 'Loading' ? this.formOperationalActivity.cargoType : null,
        'cargoLoading': this.formOperationalActivity.reasonId.split('|')[1] === 'Loading' ? Number(this.formOperationalActivity.cargoLoading) : null,
        'cargoUnloading': this.formOperationalActivity.reasonId.split('|')[1] === 'Unloading' ? Number(this.formOperationalActivity.cargoUnloading) : null,
      }

      // if(payload.portLoadingOther) payload.portLoading = null
      // if(payload.portDischargeOther) payload.portDischarge = null

      if (this.formOperationalActivity.voyageActivityType === 'UNTOWING') {
        delete payload.vehicles
      } else if (this.formOperationalActivity.voyageActivityType === 'SINGLE_TOWING') {
        payload.vehicles.splice(1, 1)
      }

      const id = this.$route.query.vehicleId
      this.$swal.fire({
        title: 'Processing...',
        allowEscapeKey: false,
        allowOutsideClick: false,
        onOpen: () => {
          swal.showLoading()
        }
      })
      
      let res
      if(!this.isEdit){
        res = await this.createVoyageActivity({ id, data: payload })
      } else {
        res = await this.updateActivityV2({ id: this.isActivityId, vehicleId: id, data: payload })
      }

      if(res?.data?.status === false){
        this.$swal('Something went wrong!', res.data.message, 'error')
        return
      }

      this.$swal('Activity Saved!', res.data.message, 'success')
      this.$router.push(`/ops/operational?vehicleId=${id}`)
    } catch (err) {
      console.log(err)
      this.$swal(
        'Error',
        'Something wrong with the server. Please try again later.',
        'error'
      )
    }
  },
  async saveActivity () {
    this.loadingSubmit = true
    try {
      if(!this.formOperationalActivity.activityType && !this.formOperationalActivity.tripId){
        this.saveOldActivity()
        return
      }

      if(this.formOperationalActivity.activityType === 'non trip'){
        this.saveNonTripActivity()
        return
      }

    // if(this.errorValidation) return this.$swal(
    //   'Error',
    //     this.errorTimeText,
    //   'warning'
    // )

    let self = this
    let payload = {
      ...this.formOperationalActivity,
      'subProjectId': this.formOperationalActivity?.subProjectId,
      polDraughtSurvey: Number(this.formOperationalActivity.polDraughtSurvey),
      podDraughtSurvey: Number(this.formOperationalActivity.podDraughtSurvey),
      "destination": this.formOperationalActivity.destination,
      "destinationOther": this.formOperationalActivity.destinationOther,
      "origin": this.formOperationalActivity.origin,
      "originOther": this.formOperationalActivity.originOther,
      "currentPosition": this.formOperationalActivity.currentPosition,
      "currentPositionOther": this.formOperationalActivity.currentPositionOther,
      'startDate': this.formOperationalActivity.startDate || null,
      'endDate': this.formOperationalActivity.endDate || null,
      'vehicles': this.formOperationalActivity.voyageActivityType === 'SINGLE_TOWING' ?  [
        {
          'vehicleId': this.formOperationalActivity.vehicles[0].vehicleId,
          'vehicleNumber': 1,
          'breakdown': this.formOperationalActivity.vehicles[0].breakdown
        }
      ] : this.formOperationalActivity.voyageActivityType === 'DOUBLE_TOWING' ? [
        {
          'vehicleId': this.formOperationalActivity.vehicles[0].vehicleId,
          'vehicleNumber': 1,
          'breakdown': this.formOperationalActivity.vehicles[0].breakdown
        },
        {
          'vehicleId': this.formOperationalActivity.vehicles[1].vehicleId,
          'vehicleNumber': 2,
          'breakdown': this.formOperationalActivity.vehicles[1].breakdown
        }
      ] : [],
      'voyageActivityType': this.formOperationalActivity.voyageActivityType,
      'polCargoUnit': this.formOperationalActivity.polCargoUnit,
      'podCargoUnit': this.formOperationalActivity.polCargoUnit,
      'subProjectId': this.formOperationalActivity?.subProjectId,
      'reasonId': Number(this.formOperationalActivity.reasonId.split('|')[0]),
      'cargoType': this.formOperationalActivity.reasonId.split('|')[1] === 'Loading' ? this.formOperationalActivity.cargoType : null,
      'cargoLoading': this.formOperationalActivity.reasonId.split('|')[1] === 'Loading' ? Number(this.formOperationalActivity.cargoLoading) : null,
      'cargoUnloading': this.formOperationalActivity.reasonId.split('|')[1] === 'Unloading' ? Number(this.formOperationalActivity.cargoUnloading) : null,
      'remarks': this.formOperationalActivity.remarks,
      'portLoading': this.formOperationalActivity.portLoading,
      'portLoadingOther': this.formOperationalActivity.portLoadingOther,
      'portDischarge': this.formOperationalActivity.portDischarge,
      'portDischargeOther': this.formOperationalActivity.portDischargeOther,
      'agentPol': this.formOperationalActivity.agentPol,
      'agentPod': this.formOperationalActivity.agentPod,
      'lat': Number(this.formOperationalActivity.lat),
      'lon': Number(this.formOperationalActivity.lon),
      'speed': Number(this.formOperationalActivity.speed || 1),
      'pic': this.picSelected,
      'dmsLatitude': this.combineDNSLat,
      'dmsLongitude': this.combineDNSLng,
      "activityType": this.formOperationalActivity.activityType,
      shelter: this.formOperationalActivity.shelter?.length > 0 && this.useShelter ? this.formOperationalActivity?.shelter?.map(val => {
        return val
      }) : []
    }

    if(payload.portLoading === 'Other') {
      payload.portLoading = null
    } else {
      payload.portLoadingOther = ''
    }
    if(payload.portDischarge === 'Other') {
      payload.portDischarge = null
    } else {
      payload.portDischargeOther = ''
    }

    if (this.formOperationalActivity.voyageActivityType === 'UNTOWING') {
      delete payload.vehicles
    } else if (this.formOperationalActivity.voyageActivityType === 'SINGLE_TOWING') {
      payload.vehicles.splice(1, 1)
    }

    if(this.unfinishedTrip.length > 0){
      let unfinishedTripData = this.unfinishedTrip.find(obj => obj.checked)

      if(unfinishedTripData){
        payload.tripId = unfinishedTripData.id
      }
    }
    //  else {
    //   payload.newTrip = true
    // }

    if(this.crossTripList.length > 0 && payload.isCrossTrip){
      let crossTripData = this.crossTripList.find(obj => obj.checked)

      if(crossTripData){
        payload.tripId = crossTripData.id
        payload.isCrossTrip = true
      }
    }

    if(this.formOperationalActivity.reasonId && this.formOperationalActivity.reasonId.split('|')[1]  !== 'Unloading'){
      payload.endOfTrip = false
    }

    const id = this.$route.query.vehicleId
    this.$swal.fire({
      title: 'Processing...',
      allowEscapeKey: false,
      allowOutsideClick: false,
      onOpen: () => {
        swal.showLoading()
      }
    })

    if (!this.isEdit) {
      let res = await self.createVoyageActivity({ id, data: payload })
      if (res.status === 'success') {
        this.$swal('Add Activity Success!', res.data.message, 'success')
        setTimeout(() => {
          this.$router.go(-1)
        }, 500)
        this.initActivityForm(1)
        this.nextStep = false
        this.loadingCheck = true

        if(payload.newTrip) delete payload?.tripId
      } else {
        if (res.data.message != null) {
          this.$swal('Error', res.data.message, 'error')
          this.loadingCheck = false
        } else {
          this.$swal(
            'Error',
            'Something wrong with the server. Please try again later.',
            'error'
          )
          this.loadingCheck = false
        }
      }
    } else {
      let res = await self.updateActivityV2({ id: this.isActivityId, vehicleId: this.fleetEdit.id, data: payload })
      if (res.status == 'success') {
        this.getActivityDetail(this.isActivityId)
        this.getLastActivity()

        this.$swal('Update Activity Success!', res.data.message, 'success')
        this.$router.push(`/ops/operational?vehicleId=${this.fleetEdit.id}&preview=false`)
      } else {
        if (res.data.message != null) {
          this.$swal('Error', res.data.message, 'error')
        } else {
          this.$swal(
            'Error',
            'Something wrong with the server. Please try again later.',
            'error'
          )
        }
      }
    }
    } catch (error) {
      console.error('Error saving activity:', error)
      this.$swal('Error', 'An error occurred while saving the activity.', 'error')
    } finally {
      this.loadingSubmit = false
    }
  },
  async onDeleteActivity (activityData) {
    let activity = activityData

    this.$swal({
      title: 'Delete Activity?',
      text: `Activity ${activity.activityName} will be deleted and cannot be recovered.`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Delete'
    }).then(async (result) => {
      if (result.isConfirmed) {
        const vehicleId = this.$route.query.vehicleId
        let res = await this.deleteActivityById({ vehicleId, id: activity.id })
        if (res.status != 'success') {
          if (res?.data?.message != null) {
            this.$swal('Error', res?.data?.message, 'error')
          } else {
            this.$swal(
              'Error',
              'Something wrong with the server. Cannot get user data.',
              'error'
            )
          }
        } else {
          setTimeout(() => {
            this.$router.go(-1)
          }, 500)
          this.initActivityForm(1)
          this.nextStep = false
          this.loadingCheck = true
          this.$swal(
            `Activity deleted!`,
            `Activity ${activity.activityName} successfully deleted`,
            'success'
          )
        }
      }
    })
  },
  cancelEdit () {
    this.$router.go(-1)
    this.isEdit = false
    this.nextStep = false
    this.loadingCheck = false
    this.initActivityForm(1)
  }
}
}
</script>

<style scoped>
.custom-date-picker {
  /* Add your custom styles here */
  width: 100%;
}
.v-menu__content {
  position: absolute !important;
}
.font-semibold{
  font-weight:600;
}
</style>
